{
  "404.message": "Sidan du försökte nå kunde inte hittas. Detta kan bero på:",
  "404.message.reason1": "Denna sida existerar inte.",
  "404.message.reason2": "Sidan existerar men du är inte behörig att visa den.",
  "404.nav.dashboard": "Din dashboard",
  "404.nav.home": "Platsens hemsida",
  "404.nav.title": "Gå till",
  "404.search.title": "Webbplatssökning",
  "aboutpage.section.title": "Insticksprogram för Atlassian Confluence Cloud och Confluence Cloud",
  "accessibility.user.icon": "Användarikon",
  "action.add.comment": "Lägg till kommentar",
  "action.edit.comment": "Redigera kommentar",
  "action.reorder.pages.sentence": "Arrangera om sidor",
  "action.space.addons": "Tillägg",
  "action.space.overview": "Överblick",
  "actions.word": "Åtgärder",
  "add.comment": "Lägg till kommentar",
  "add.comment.accesskey": "m",
  "add.shortcut": "Lägg till genväg",
  "add.word": "Lägg till",
  "addlabels.teamlabels": "Kategorier",
  "adf.translation.error.in.render.description.prod": "Uppdatera sidan och försök igen. Om problemet kvarstår, kontakta <a target=\"_blank\" href=\"{link}\">Atlassian-supporten</a>.",
  "adf.translation.error.in.render.description.staging": "Ett ADF-fel förhindrar ditt innehåll från att visas. Du kan diskutera detta i kanalen <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> i Slack.",
  "adf.translation.error.in.render.title.prod": "Vi kunde inte visa ditt innehåll",
  "adf.translation.error.in.render.title.staging": "ADF-fel när innehållet skulle visas",
  "adg3.feedback.placeholder": "Berätta om din upplevelse av Confluence så att vi kan göra det ännu bättre.",
  "adg3.give.feedback": "Ge feedback",
  "adg3.onboarding.docs.link": "Lär dig mer",
  "adg3.onboarding.next": "Nästa",
  "adg3.onboarding.prev": "Föregående",
  "adg3.onboarding.sidebar.done": "Jag förstår",
  "adg3.onboarding.skip": "Hoppa över",
  "adg3.onboarding.start": "Kom igång",
  "adg3.onboarding.step1.content": "Vi har uppdaterat färger, ikoner och typsnitt så att viktiga saker är lättare att upptäcka och dina ögon inte måste jobba så hårt.",
  "adg3.onboarding.step1.title": "Säg goddag till den nya Confluence-upplevelsen",
  "adg3.onboarding.step2.content": "Sakerna du behöver mest – sök, skapa och navigera – finns alla i sidofältet.",
  "adg3.onboarding.step2.title": "Enkel sidofältsnavigering",
  "adg3.onboarding.step3.content": "Minns du inte vad du arbetade på? Sökpanelen hjälper dig med en lista över dina nyligen visade sidor.",
  "adg3.onboarding.step3.title": "Fortsätt där du slutade",
  "adg3.onboarding.step4.content": "Lämna feedback via din profil för att hjälpa oss göra detta ännu bättre. Inte redo för den nya upplevelsen än? Du kan även stänga av den via din profil.",
  "adg3.onboarding.step4.content.no.optout": "Din feedback spelar stor roll i att förbättra Confluence-upplevelsen. Låt oss veta vad du tycker via din profil för att hjälpa oss göra det här ännu bättre.",
  "adg3.onboarding.step4.title": "Hjälp oss att göra Confluence så bra som möjligt",
  "adg3.onboarding.user.optin.content": "Vi har gjort ändringar baserat på din feedback, men vi förbättrar oss fortfarande. Lämna oss ett meddelande via Ge feedback I sidpanelen om du har mer som du vill dela med dig av.",
  "adg3.onboarding.user.optin.done": "Jag förstår",
  "adg3.onboarding.user.optin.title": "Den nya Confluence-upplevelsen är nu här för alla",
  "adg3.send.feedback": "Skicka feedback",
  "adg3.sidebar.button.configure": "Konfigurera sidpanel",
  "adg3.sidebar.button.done": "Klar",
  "adg3.sidebar.button.gotit": "Jag förstår",
  "adg3.sidebar.link.disable": "Inaktivera",
  "adg3.sidebar.link.enable": "Aktivera",
  "adg3.user.profile.other": "Mitt Confluence",
  "admin.section.security.title": "Användare och säkerhet",
  "administration.name": "Administration",
  "all.updates.mainBanner": "Det händer inte så mycket ... Än",
  "all.updates.subBanner": "Håll dig à jour med allt som händer på denna webbplats. Nya sidor, filer, redigeringar och kommentarer kommer alla att visas här.",
  "all.updates.subBanner2": "Dags att skapa nästa stora grej.",
  "all.updates.title": "Alla uppdateringar",
  "anonymous.name": "Anonym",
  "archived.spaces": "Arkiverade utrymmen",
  "atlassian.can.contact": "Får vi kontakta dig för att göra en uppföljning på din feedback?",
  "atlassian.home.name": "Atlassian Home",
  "attach.files.no.permission": "Du måste be om tillåtelse för att infoga filer här.",
  "attach.files.tip.close": "Okej, jag förstår!",
  "attach.files.tip.desc": "Släpp filer på sidan för att infoga dem direkt.",
  "attach.files.tip.title": "Tips:",
  "attach.files.upload.files": "Ladda upp filer",
  "attach.files.upload.images": "Ladda upp bilder",
  "audit.logging.category.user.management": "Användare och grupper",
  "aui.sidebar.collapse.tooltip": "Dölj sidofält ( [ )",
  "aui.sidebar.expand.tooltip": "Expandera sidofält ( [ )",
  "author.name": "Upphovsman",
  "blog.personal.name": "Personlig blogg",
  "blog.post": "Blogginlägg",
  "blog.word": "Blogg",
  "blogtree.failed.load.content": "Det gick inte att läsa in blogginlägg",
  "blueprint.navigation.items.create.new.template": "Skapa ny mall",
  "blueprint.navigation.items.create.new.template.disabled": "Endast utrymmesadministratörer kan skapa mallar",
  "blueprint.navigation.items.filter.for.templates": "Filtermallar",
  "blueprint.navigation.items.page.templates.header": "Sidmallar",
  "button.cancel": "Avbryt",
  "cache.name.com.atlassian.confluence.pages.Draft": "Utkast",
  "calendar.share.button.keyboard.shortcut.desc": "Dela",
  "calendar3.addcalendar": "Lägg till kalender",
  "calendar3.helptip.learn.more": "Lär dig mer",
  "calendar3.spacecalendars.header": "Kalendrar",
  "calendar3.spacecalendars.onboarding.button.add.label": "Lägg till kalender",
  "calendar3.spacecalendars.onboarding.intro": "Lägg till en kalender för att övervaka ditt teams ledigheter, planera Jira-projekt och koordinera alla kring viktiga datum.",
  "calendar3.spacecalendars.onboarding.title": "Källan till sanningen för ditt team eller projekt",
  "cancel.name": "Avbryt",
  "captcha.response.failed": "Det angivna ordet matchade inte texten på bilden.",
  "categories.name": "Kategorier",
  "changeboarding.dnd.pagetree.spacesettings.banner": "En ny dra och släpp-funktion gör det enklare att flytta runt och ordna sidorna i sidofältet.",
  "changeboarding.dnd.pagetree.spotlight.message": "Dra och släpp för att flytta sidor och organisera ditt utrymme.",
  "changes-diff.heading.key": "Nyckel",
  "changes-diff.these.lines.were.added": "Denna rad lades till.",
  "changes-diff.these.lines.were.removed": "Denna rad togs bort.",
  "changes-diff.this.content.was.modified": "Formateringen ändrades.",
  "clear.name": "Rensa",
  "clipboardaccess.browser.not.supported": "Din webbläsare stöder inte att klistra in bilder från urklipp.",
  "clipboardaccess.ok": "Okej",
  "close.draft.name": "Stäng utkast",
  "close.name": "Stäng",
  "collab.edit.user.limit.msg.body": "<p>Denna sida är väldigt populär. Du har uppnått maximalt antal samtidiga redigerare.</p><p>Försök igen när den inte är lika upptagen.</p>",
  "collab.edit.user.limit.msg.title": "Du kan inte redigera denna sida just nu",
  "collab.status.connected": "Klar att köra",
  "collab.status.connecting": "Ansluter ...",
  "collab.status.error": "Kan inte spara ändringar",
  "collab.status.tooltip.error": "Kopiera ditt arbete och uppdatera sidan, så försöker vi ansluta igen.",
  "collab.status.tooltip.failure": "Kan inte nå servern. Kontrollera din internetuppkoppling så fortsätter vi att försöka koppla upp dig igen.",
  "collab.status.tooltip.success": "Vi sparar dina ändringar automatiskt",
  "collapse.name": "Dölj",
  "colourname.property.style.bordercolour": "Kantlinjer och avgränsare",
  "colourname.property.style.breadcrumbstextcolour": "Text på toppfält",
  "colourname.property.style.headerbuttonbasebgcolour": "Sidhuvudknappens bakgrund",
  "colourname.property.style.headerbuttontextcolour": "Sidhuvudknappens text",
  "colourname.property.style.headingtextcolour": "Rubriktext",
  "colourname.property.style.linkcolour": "Länkar",
  "colourname.property.style.menuitemselectedbgcolour": "Bakgrund för markerat menyobjekt",
  "colourname.property.style.menuitemselectedtextcolour": "Text för markerat menyobjekt",
  "colourname.property.style.menuitemtextcolour": "Text för sidmenyobjekt",
  "colourname.property.style.menuselectedbgcolour": "Bakgrund för markerad sidmeny",
  "colourname.property.style.navbgcolour": "Bakgrundsfärg för fliknavigering",
  "colourname.property.style.navselectedbgcolour": "Bakgrundsfärgmarkering för fliknavigering",
  "colourname.property.style.navselectedtextcolour": "Textfärgmarkering för fliknavigering",
  "colourname.property.style.navtextcolour": "Text för fliknavigering",
  "colourname.property.style.searchfieldbgcolour": "Sökfältsbakgrund",
  "colourname.property.style.searchfieldtextcolour": "Sökfältstext",
  "colourname.property.style.spacenamecolour": "Utrymmesnamnstext",
  "colourname.property.style.topbarcolour": "Toppfält",
  "colourname.property.style.topbarmenuitemtextcolour": "Text för menyobjekt i toppfältet",
  "colourname.property.style.topbarmenuselectedbgcolour": "Bakgrund för markerad toppfältsmeny",
  "colourname.property.style.topbarmenuselectedtextcolour": "Text för markerad toppfältsmeny",
  "com.atlassian.confluence.contributors.contributors.label": "Medarbetare",
  "com.atlassian.confluence.extra.officeconnector.viewfile.label": "Visa fil",
  "com.atlassian.confluence.extra.team-calendars.calendar.helptip.close": "Jag förstår, tack!",
  "com.atlassian.confluence.pages.actions.EditPageAction.action.name": "Redigera sida",
  "com.atlassian.confluence.plugins.confluence-roadmap-plugin.roadmap.label": "Översiktsplanering",
  "com.atlassian.confluence.plugins.pagetree.pagetree.label": "Sidträd",
  "com.atlassian.confluence.plugins.recently.viewed.filter": "Filtrera",
  "com.atlassian.confluence.plugins.recently.viewed.footer.hint": "Tips: skriv “g” och sedan “r” var som helst för att snabbt öppna denna meny",
  "com.atlassian.confluence.plugins.recently.viewed.title": "Nyligen visade sidor",
  "com.atlassian.confluence.plugins.status-macro.status.label": "Status",
  "com.atlassian.mywork.header.notifications": "Aviseringar",
  "comment.display.name.anonymous": "Gästanvändare",
  "comment.edit": "Redigera",
  "comment.edited": "Redigerade",
  "comment.name.tooltip": "Lägg till en kommentar",
  "comment.notification.enable": "Bevaka denna sida",
  "comment.permalink": "Permalänk",
  "comment.plural": "{0} Kommentarer",
  "comment.remove": "Radera",
  "comment.reply": "Svara",
  "comment.singular": "1 kommentar",
  "compare.selected": "Jämför markerade versioner",
  "configuration.name": "Konfiguration",
  "confluence.extra.attachments.attachments.label": "Bilagor",
  "confluence.extra.jira.jira.label": "Jira",
  "confluence.extra.masterdetail.detailssummary.label": "Page Properties Report",
  "confluence.home": "Hem för Confluence",
  "confluence.macros.advanced.children.label": "Underordnad sidvy",
  "confluence.macros.advanced.contentbylabel.label": "Innehåll enligt etikett",
  "confluence.macros.advanced.recently-updated.label": "Nyligen uppdaterad",
  "confluence.mobile.nav.switch.to.mobile.action": "Byt till Confluence mobile",
  "confluence.mobile.nav.switch.to.mobile.text": "Du visar skrivbordsversionen på en mobil enhet.",
  "confluence.mobile.refresh": "Uppdatera",
  "confluence.request.access.pagerestricted.inherited.description": "Detta är på grund av dess ärvda begränsningar från en överordnad sida. En utrymmesadministratör eller personen som delade denna sida kanske kan ge dig åtkomst.",
  "confluence.request.access.pagerestricted.request.access.button": "Begär åtkomst",
  "confluence.request.access.pagerestricted.requestaccess.description": "Tryck på knappen request access så kontaktar vi någon som kan ge dig tillgång.",
  "confluence.request.access.pagerestricted.requestaccess.title.edit.page": "Du har inte behörighet att redigera denna sida",
  "confluence.request.access.pagerestricted.requestaccess.title.view.page": "Du har inte rättighet att se denna sida",
  "confluence.user.profile.department": "Avdelning",
  "confluence.user.profile.location": "Plats",
  "confluence.user.profile.position": "Position",
  "connect.addon.wait.or": "Vänta eller",
  "content.empty": "Kommentarstexten är tom. Kan inte skapa tomma kommentarer.",
  "content.kind.decisions": "Beslut",
  "content.kind.file-list": "Fillista",
  "content.kind.jirareport": "Jira-rapport",
  "content.kind.kb-how-to-article": "Instruktionsartikel",
  "content.kind.kb-troubleshooting-article": "Felsökningsartikel",
  "content.kind.meeting-notes": "Mötesanteckningar",
  "content.kind.product-requirements": "Produktkrav",
  "content.kind.retrospective": "Retrospektiv",
  "content.kind.shared-links": "Delade länkar",
  "content.kind.task-report": "Uppgiftsrapport",
  "content.type.attachment": "Bilagor",
  "content.type.blogpost": "Nyheter",
  "content.type.page": "Sidor",
  "cq.header.title": "Frågor",
  "create.blog.post.event.description": "Skapa nyhetsinlägg",
  "create.drawer.header": "Skapa",
  "create.drawer.page.selector.all.pages.in.space": "Alla sidor i det här utrymmet",
  "create.drawer.page.selector.location.header": "Plats",
  "create.drawer.page.selector.no.page.found": "Inga sidor hittades",
  "create.drawer.page.selector.no.parent.page": "Ingen överordnad sida",
  "create.drawer.page.selector.pages.loading": "Läser in sidor",
  "create.drawer.page.selector.parent.page": "Överordnad sida",
  "create.drawer.page.selector.parent.page.tooltip.help": "Bloggar, kalendrar och frågor kommer inte att visas under en överordnad sida",
  "create.drawer.page.selector.recent.pages": "Senaste sidor",
  "create.drawer.page.selector.select.parent.page": "Välj en överordnad sida",
  "create.drawer.space.selector.header": "Utrymme",
  "create.drawer.space.selector.location.header": "Plats",
  "create.drawer.space.selector.no.space.found": "Inga utrymmen hittades",
  "create.drawer.space.selector.recent.spaces": "Senaste utrymmen",
  "create.drawer.space.selector.search.spaces": "Alla utrymmen",
  "create.drawer.space.selector.select.a.space": "Välj ett utrymme",
  "create.drawer.space.selector.spaces.loading": "Läser in utrymmen",
  "create.drawer.space.selector.starred.spaces": "Stjärnmärkta utrymmen",
  "create.drawer.template.failed.to.load.atlassian.support": "Atlassian-supporten.",
  "create.drawer.template.failed.to.load.content": "Uppdatera sidan och försök igen. Om problemet kvarstår, kontakta",
  "create.drawer.template.failed.to.load.title": "Mallen kunde inte läsas in",
  "create.name": "Skapa",
  "css.file": "CSS-fil",
  "current.space": "Aktuell plats",
  "default.space.homepage.title": "{0} Hem",
  "delete.name": "Radera",
  "desc.colourscheme": "Följande färger kan anpassas för det här färgschemat.",
  "description.name": "Beskrivning",
  "discard.name": "Ignorera",
  "discover.applications": "Upptäck applikationer",
  "draft": "Utkast",
  "draft.no.content": "Detta utkast har inget innehåll.",
  "edit.comment": "Redigera kommentar",
  "edit.labels": "Lägg till etiketter",
  "editor-help.fabric.help.center.feedback.item": "Feedback",
  "editor.adf.parsing.error.details": "Felinformation:",
  "editor.adf.parsing.error.message.prod": "Uppdatera sidan och försök igen. Om problemet kvarstår, kontakta <a target=\"_blank\" href=\"{link}\">Atlassian-supporten</a>.",
  "editor.adf.parsing.error.message.staging": "Vårt team har meddelats, men du kan också diskutera detta i kanalen <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> i Slack.",
  "editor.adf.parsing.error.title.prod": "Vi kunde inte läsa in redigeraren.",
  "editor.adf.parsing.error.title.staging": "Det uppstod ett problem när vi skulle konvertera dokumentet till ADF",
  "editor.attachments": "{0}",
  "editor.attachments.plural": "{0} Bilagor",
  "editor.attachments.singular": "{0} Bilaga",
  "editor.attachments.zero": "Bilagor",
  "editor.autocomplete.file.header.text": "Filförslag",
  "editor.autocomplete.links.create.link": "Infoga länk för att skapa sida",
  "editor.autocomplete.links.dialog.search": "Sök efter ‘{0}’",
  "editor.autocomplete.links.dialog.search.no.text": "Sök",
  "editor.autocomplete.links.header.text": "Länkförslag",
  "editor.autocomplete.links.web.link": "Infoga weblänk",
  "editor.autocomplete.macros.dialog.browse": "Öppna makrobläddrare",
  "editor.autocomplete.macros.error.load.header": "Misslyckades med att hämta makroinformation",
  "editor.autocomplete.macros.error.load.retrylink": "Försök igen",
  "editor.autocomplete.macros.header.text": "Makroförslag",
  "editor.autocomplete.media.files.dialog.browse": "Öppna filbibliotek",
  "editor.autocomplete.media.header.text": "Mediaförslag",
  "editor.autocomplete.media.images.dialog.browse": "Öppna bildbläddrare",
  "editor.autocomplete.media.macros.dialog.browse": "Infoga annan media",
  "editor.autoformat.sampletext.firstcell": "första cellen",
  "editor.autoformat.sampletext.heading": "rubrik",
  "editor.buttons.disable.by.empty.title.tooltip": "Din sida behöver en titel innan den kan publiceras.",
  "editor.buttons.disable.by.not.saving.tooltip": "Arbetar fortfarande ...",
  "editor.buttons.disable.by.saving.tooltip": "Vi sparar fortfarande din sida.",
  "editor.cancel.discard.changes.confirmation": "Kassera ändringar",
  "editor.cancel.discard.changes.message": "Allt inskrivet innehåll kommer att kasseras. Vänligen bekräfta.",
  "editor.cancel.discard.changes.title": "Bekräfta kassering av alla ändringar",
  "editor.cant.publish.changes": "Kan inte publicera ändringar",
  "editor.change.comment": "Vad ändrade du?",
  "editor.close.publish.tooltip": "Spara ändringar utan att publicera",
  "editor.close.update.tooltip": "Spara ändringar utan att uppdatera",
  "editor.collab.user.limit.body": "Den här sidan är så populär att du har uppnått det maximala antalet samtidiga redigerare. Försök igen senare.",
  "editor.collab.user.limit.title": "Du kan inte redigera den här sidan just nu.",
  "editor.collaborative-editing.load.error": "Det tar längre tid än vanligt att ladda editorn. Vänta en liten stund och uppdatera sedan sidan om den fortfarande inte laddas. Prata med din Confluence-administratör om det inte löser problemet.",
  "editor.collaborative-editing.refresh-editor.error": "Något gick fel när editorn laddades, vänligen försök igen.",
  "editor.collaborative.mode.disabled": "Kollaborativ redigering är offline för tillfället. Kopiera ditt arbete och uppdatera sedan sidan för att fortsätta redigera.",
  "editor.collaborative.mode.enabled": "Kollaborativ redigering var avstängt, men nu är det igång igen. Kopiera dina ändringar och uppdatera sidan för att fortsätta redigera.",
  "editor.content.appearance.toggle.fixed.width": "Gör sidan till helbredd",
  "editor.content.appearance.toggle.full.width": "Gör sidan till fast bredd",
  "editor.content.placeholder.11": "Visste du att du kan lägga till massor av coola saker på den här sidan, till exempel en innehållsförteckning eller en färdplan. Skriv / för att öppna en lista.",
  "editor.content.placeholder.ai": "Skriv /ai för Atlassian Intelligence, / för att lägga till element, eller @ för att nämna någon (vi meddelar dem).",
  "editor.content.placeholder.bpqa": "Ange / för att se en lista med element, @ för att nämna någon eller välj nedan:",
  "editor.content.placeholder.bpqa.ai": "Skriv /ai för Atlassian Intelligence, / för element, @ för att nämna någon eller välj nedan:",
  "editor.content.placeholder.easy.mentions": "Ange / för alla element eller @ för att nämna någon.",
  "editor.content.placeholder.slash": "Ange / för att infoga ett element",
  "editor.content.placeholder.slash.bracket": "Du kan snabbt infoga valfritt element genom att ange /",
  "editor.content.reconciliation.error.details": "Felinformation:",
  "editor.content.reconciliation.error.fatal.prod": "Vårt team har meddelats. Vänta några minuter och försök igen. Kontakta supporten om problemet kvarstår.",
  "editor.content.reconciliation.error.fatal.staging": "Vårt team har meddelats, men du kan också diskutera detta i kanalen #cc-content-experience i Slack.",
  "editor.content.reconciliation.error.retrying": "Försöker igen om {0} ...",
  "editor.content.reconciliation.error.title": "Den här sidan kunde inte läsas in",
  "editor.content.reconciliation.networkerror.fatal.prod": "Att uppdatera sidan bör lösa det här problemet. Kontakta <a href=\"https://support.atlassian.com/contact/#/\" target=\"_blank\">Atlassians support</a> eller din utrymmesadministratör om problemet kvarstår.",
  "editor.content.reconciliation.networkerror.title": "Vi har problem med att läsa in ditt innehåll",
  "editor.discard-on-close.tooltip": "Kasta tomt utkast",
  "editor.discard-to-published.button.label": "Kassera",
  "editor.discard-to-published.button.tooltip": "Återgå till den senast publicerade versionen av sidan",
  "editor.discard-to-published.dialog.title": "Kassera opublicerade ändringar?",
  "editor.discard-to-published.dialog.warning": "Detta kommer att återställa editorn till den senast publicerade versionen av denna sida. Om någon annan har opublicerade ändringar på sidan, kommer du att kassera dessa också.",
  "editor.discard-to-published.error.message": "Vi kan inte hämta den senast publicerade versionen av sidan för tillfället. Vänta en liten stund och försök sedan att kassera utkastet igen.",
  "editor.discard-to-published.error.title": "Kan inte återgå till den senast publicerade versionen",
  "editor.discard-to-published.success.message": "Återställningen av den senast publicerade versionen lyckades",
  "editor.draft.can.be.migrated": "Kollaborativ redigering är här! För att du ska kunna fortsätta arbeta på denna sida måste vi migrera innehållet till ett nytt utkast åt dig.<br> <a href={0}>Migrera nu</a>",
  "editor.dynamic-macro.preview.limit.desc": "Förhandsgranskning av dynamiskt makro på utkast stöds fullt ut endast när delade utkast är aktiverat.",
  "editor.ellipsis.blog.delete": "Radera opublicerat blogginlägg",
  "editor.ellipsis.import-document": "Öppna en mall och importera dokument",
  "editor.ellipsis.open.template.browser": "Öppna mallwebbläsare",
  "editor.ellipsis.open.templates.and.import": "Mallar och importera dokument",
  "editor.ellipsis.page.delete": "Radera opublicerad sida",
  "editor.ellipsis.remove": "Återgå till senast publicerade version",
  "editor.ellipsis.resolved.comments": "Lösta kommentarer",
  "editor.ellipsis.view-changes": "Visa ändringar",
  "editor.error.delayed.publishing": "Vi fortsätter att försöka publicera. Om det tar för lång tid kan du uppdatera sidan och klicka på <strong>Publicera</strong>.",
  "editor.error.delayed.publishing.title": "Vi har problem med att publicera ditt innehåll.",
  "editor.excerpt.include.macro.error": "Fel vid inläsning av utdrag från \"{0}\".",
  "editor.excerpt.panel.title.loading": "Läser in ...",
  "editor.fabric.share.invite.to.edit.empty.blog.post.title": "Blogginlägg utan titel",
  "editor.fabric.share.invite.to.edit.empty.page.title": "Sida utan titel",
  "editor.fabric.share.invite.to.edit.form.title": "Bjud in att redigera",
  "editor.files.may.be.uploading": "Vissa filer kanske fortfarande håller på att överföras. Vänta en minut och försök sedan på nytt. Om det inte fungerar ska du uppdatera sidan och sedan överföra alla filer som ser trasiga ut igen innan du publicerar.",
  "editor.generic.refresh": "Något gick fel med editorn. Kopiera dina ändringar som inte sparats och uppdatera sidan för att fortsätta redigera.",
  "editor.go.back": "Gå tillbaka",
  "editor.heartbeat.unauthorised.warning.generic.body": "Detta innehåll har flyttats, begränsats eller raderats. Vi rekommenderar att du kopierar allt du behöver och stänger editorn.",
  "editor.heartbeat.unauthorised.warning.generic.title": "Ingen åtkomst till denna sida",
  "editor.heartbeat.unauthorised.warning.page-move.body": "Du kan inte publicera på grund av ändrade restriktioner eller att en sida har flyttats. Vi rekommenderar att du kopierar allt du behöver och stänger editorn.",
  "editor.heartbeat.unauthorised.warning.page-move.title": "Sidbehörigheterna har ändrats",
  "editor.help.how.to.use.blueprint": "Hur du använder {blueprintType}",
  "editor.help.templates": "Använd sidmallar",
  "editor.help.updates": "Redigeringsuppdateringar",
  "editor.help.updates.1.description": "Den första fasen med redigeringsförbättringar har kommit till blogginlägg. Responsivt innehåll, bättre bildhantering och ett mer strömlinjeformat användargränssnitt. Skapa ett nytt blogginlägg för att testa.",
  "editor.help.updates.1.title": "Blogginlägg",
  "editor.help.updates.2.description": "Den nya redigeringsupplevelsen har nu lanserats för mötesanteckningar. De senaste uppdateringarna innefattar avancerade tabellfunktioner, vilka växlas av och på genom att klicka på en tabell, samt förbättrad hastighet och tillförlitlighet.",
  "editor.help.updates.2.title": "Mötesanteckningar",
  "editor.hints.close": "Stäng tips",
  "editor.hints.next": "Nästa tips",
  "editor.labels": "{0}",
  "editor.labels.desc": "Redigera sidetiketter",
  "editor.labels.plural": "{0} Etiketter",
  "editor.labels.singular": "{0} Etikett",
  "editor.labels.zero": "Etiketter",
  "editor.learn.more": "Läs mer",
  "editor.location.desc": "Lägg till plats",
  "editor.minor.edit": "Meddela bevakare",
  "editor.offline.before.save.error": "Kan inte kommunicera med servern. Det är inte möjligt att spara för tillfället.",
  "editor.offline.preview.error": "Kan inte nå servern. Kontrollera att du är ansluten till internet och att Confluence körs.",
  "editor.offline.save.error": "Kan inte nå servern. Det går inte att spara just nu.",
  "editor.offline.save.error.generic": "Det uppstod ett fel vid hantering av begäran.",
  "editor.offline.save.noauthorized": "Din session har gått ut. Logga in igen eller byt till ett annat konto för att fortsätta arbeta.\n <div><a href=\"/login?application=confluence\">Logga in eller byt till ett annat konto</a></div>",
  "editor.offline.save.noauthorized.title": "Kan inte ansluta till server",
  "editor.offline.save.page.exist.content": "Det finns redan en sida med rubriken ”'{'0'}'” i det här utrymmet. Ange en annan rubrik för din sida.",
  "editor.onboarding.draft.placeholder": "Skriv / för att se en lista med användbara element som du kan lägga till på sidan, till exempel en innehållsförteckning eller en översikt.<br/>Om du behöver mer inspiration kan du börja med en av mallarna till höger →",
  "editor.onboarding.spotlight.body": "Se vad som ändras och varför.",
  "editor.onboarding.spotlight.finish": "Jag förstår",
  "editor.onboarding.spotlight.title": "Vi uppdaterar våra mallar, en i taget",
  "editor.onboarding.step1.content": "JVi jobbar på att leverera funktionerna ni har bett om, till att börja med bättre läsbarhet, smidigare formateringsverktyg och ett modernare utseende. <br /><a href=''{linkCAC}' target='_blank'>Läs mer om förändringarna</a>",
  "editor.onboarding.step1.title": "Vänligare blogginlägg",
  "editor.onboarding.step2.content": "Dina mest använda funktioner finns i verktygsfältet, och mer avancerade verktyg finns under plustecknet. Det finns också en mängd nya emojis som kan göra din dag roligare! <br/><a href=''{linkCAC}' target='_blank'>Läs mer om förändringarna</a>",
  "editor.onboarding.step2.title": "Letar du efter något?",
  "editor.onboarding.step3.content": "Detta är ett pågående arbete, och vi behöver din hjälp för att göra det perfekt. Skicka oss din feedback och följ <a href=''{linkCAC}' target='_blank'>Confluence-sidan</a> för att hålla dig uppdaterad om ändringar. <br/><a href=''{linkCAC}' target='_blank'>Läs mer om förändringarna</a>",
  "editor.onboarding.step3.title": "Låt oss skapa något fantastiskt tillsammans",
  "editor.page.can.not.be.accessed.message": "Din session har gått ut. Logga in igen eller byt till ett annat konto för att fortsätta arbeta.\n <div><a href=\"/login?application=confluence\">Logga in eller byt till ett annat konto</a></div>",
  "editor.page.can.not.be.accessed.title": "Detta innehåll är inte åtkomligt.",
  "editor.page.conflict.message": "Ladda om sidan för att försöka ansluta igen.",
  "editor.page.conflict.title": "Kan inte synkronisera med server.",
  "editor.page.is.too.big": "Sidan är för stor för att spara. Du kan dela upp den i flera sidor och sedan använda <a href=\"https://confluence.atlassian.com/conf51/include-page-macro-336169384.html\" target=\"_blank\">makrot för att inkludera sida</a> för att visa innehållet.",
  "editor.page.is.trashed.message": "Kopiera ditt innehåll och lägg sen till det på en ny sida eller <div><a href=\"{0}/pages/viewtrash.action?key={1}\" target=\"_blank\">återställ den här sidan från papperskorgen</a> och försök igen.</div>",
  "editor.page.is.trashed.title": "Innehållet har raderats.",
  "editor.page.legacy.draft.deprecated": "Kollaborativ redigering är här! Det innebär att vi behöver lite hjälp av dig för att starta om din redigeringssession. Allt du behöver göra är att kopiera innehållet, redigera sidan igen och sedan klistra in det och spara.",
  "editor.page.moved.message.body": "Men det är ok – du kan fortfarande publicera ändringar när du är redo. <br /><br /> Ny plats: {0}",
  "editor.page.moved.message.title": "{0} flyttade denna sida",
  "editor.page.moved.message.unknown.mover": "En annan användare",
  "editor.placeholder.broken.image": "Trasig bild",
  "editor.placeholder.broken.link": "Trasig länk",
  "editor.placeholder.broken.macro": "Trasigt makro",
  "editor.placeholder.error": "Fel",
  "editor.preview.error": "Ett fel inträffade när förhandsgranskningen laddades. Vänligen försök igen senare.",
  "editor.publish.blog": "Publicera",
  "editor.publish.blog.desc": "Publicera ditt blogginlägg",
  "editor.publish.external.share.label": "Delas externt",
  "editor.publish.hotkey.description": "Välj {keyCombination} på tangentbordet för att publicera innehållet.",
  "editor.publish.with.comment": "Publicera med versionskommentar ...",
  "editor.publish.without.notify": "Publicera utan att meddela bevakare",
  "editor.quit-dialog.button.delete.blog.exit": "Radera blogginlägg",
  "editor.quit-dialog.button.delete.page.exit": "Radera sida",
  "editor.quit-dialog.button.discard.changes.by.many": "Kasta <strong>allas</strong> ändringar",
  "editor.quit-dialog.button.discard.changes.by.one": "Kasta <strong>alla</strong> ändringar",
  "editor.quit-dialog.button.discard.collaborative.tooltip": "Kassera alla opublicerade ändringar",
  "editor.quit-dialog.button.discard.limited.tooltip": "Kollaborativ redigering har avaktiverats. Du kan kassera ändringar när det aktiverats igen.",
  "editor.quit-dialog.button.revert.blog.exit": "Återställ blogginlägg",
  "editor.quit-dialog.button.revert.page.exit": "Återställ sida",
  "editor.quit-dialog.button.save.exit": "Behåll utkast",
  "editor.quit-dialog.cancel.changes.by.many": "<p>Det finns ändringar som har gjorts av dig och andra människor som inte har blivit publicerade än.</p>\n<p>Om du kastar ändringar kommer du radera ändringar som gjorts av följande människor, och återgå till den senaste publicerade versionen av den här sidan. De kommer inte att kunna återställa sina arbeten om du gör det här.</p>\n\n<p>De här människorna har gjort ändringar:</p>",
  "editor.quit-dialog.cancel.changes.by.one": "<p>Du har gjort ändringar som inte har publicerats än.</p><p>Om du kastar ändringar kommer dina opublicerade ändringar att raderas. Du kan inte ångra den här handlingen.</p>",
  "editor.quit-dialog.delete.blogpost.changes.by.many": "Detta kommer att permanent radera detta blogginlägg som du och andra har arbetat på.",
  "editor.quit-dialog.delete.blogpost.changes.by.one": "När du har raderat ett opublicerat blogginlägg är det borta för alltid.",
  "editor.quit-dialog.delete.page.changes.by.many": "Detta kommer att permanent radera denna sida som du och andra har arbetat på.",
  "editor.quit-dialog.delete.page.changes.by.one": "Om du raderar en opublicerad sida är den borta för alltid.",
  "editor.quit-dialog.last.edited": "Senast ändrad",
  "editor.quit-dialog.link.hide.diff": "Dölj ändringar",
  "editor.quit-dialog.link.show.diff": "Visa ändringar",
  "editor.quit-dialog.publish.changes": "<p>Det finns ändringar av dig och andra som inte har publicerats ännu.</p><p>Dessa personer har gjort ändringar:</p>",
  "editor.quit-dialog.revert.blogpost.changes.by.one": "Detta kommer att permanent radera alla ändringar du gjort sedan detta blogginlägg senast publicerades",
  "editor.quit-dialog.revert.changes.by.many": "Detta kommer att permanent radera alla ändringar som följande personer har gjort efter att denna sida senast publicerades.",
  "editor.quit-dialog.revert.page.changes.by.one": "Detta kommer att permanent radera alla ändringar du gjort sedan sidan senast publicerades.",
  "editor.quit-dialog.title.blogpost.delete": "Radera opublicerat blogginlägg?",
  "editor.quit-dialog.title.discard": "Återgå till senast publicerad version?",
  "editor.quit-dialog.title.exit": "Stäng redigeraren",
  "editor.quit-dialog.title.page.delete": "Radera opublicerad sida?",
  "editor.quit-dialog.title.publish": "Publicera sidan?",
  "editor.restrictions.desc": "Redigera sidrestriktioner",
  "editor.return.to.edit": "Återvänd till redigeringsläge",
  "editor.satisfaction.survey.description": "Hur var redigeringsupplevelsen?",
  "editor.satisfaction.survey.final.description": "Din feedback har skickats in",
  "editor.satisfaction.survey.final.title": "Tack",
  "editor.satisfaction.survey.question.bad": "Det var tråkigt att höra. Vad var det som gick fel? (valfritt)",
  "editor.satisfaction.survey.question.good": "Tack! Vad tyckte du? Vad kan förbättras? (valfritt)",
  "editor.satisfaction.survey.title": "Din sida har publicerats",
  "editor.save.draft.desc": "Spara ditt utkast",
  "editor.save.page.desc": "Spara din sida",
  "editor.shared.draft.done.desc": "Spara utkast; kassera det om det är tomt",
  "editor.shared.draft.publish.desc": "Publicera ändringar",
  "editor.shared.draft.update.desc": "Uppdatera publicerad sida",
  "editor.shortcuts": "Redigerar tangentbordsgenvägar",
  "editor.synchrony.publish-page.message": "{0} publicerade denna sida.",
  "editor.template.changing.variable.dialog.title": "Redigera mallvariabel",
  "editor.template.variable.input.creation.error.action": "Besök Atlassian Support",
  "editor.template.variable.input.creation.error.description": "Uppdatera sidan och försök igen. Om problemet kvarstår kan du kontakta oss via länken nedan.",
  "editor.template.variable.input.creation.error.title": "Något gick fel",
  "editor.template.variable.list.field.placeholder": "alternativ 1, alternativ 2, alternativ 3",
  "editor.template.variable.name.field": "Variabelnamn",
  "editor.title.is.empty": "Lägg till en sidtitel innan du publicerar.",
  "editor.title.is.empty.title": "Den här sidan behöver ett namn",
  "editor.title.placeholder": "Sidtitel",
  "editor.title.too.long": "Titel får inte vara längre än 255 tecken.",
  "editor.unavailable.generic.body": "Redigering är inte tillgängligt för tillfället Försök igen om några minuter.",
  "editor.unavailable.title": "Kan inte redigera",
  "editor.unpublished.changes.lozenge.label": "Opublicerad",
  "editor.unpublished.changes.lozenge.tooltip": "Denna sida har opublicerade ändringar",
  "editor.waiting.to.publish.changes": "Det kan hända att en fil fortfarande laddas upp.",
  "editor.waiting.to.publish.changes.title": "Ha tålamod, det här tar en stund.",
  "email.text.added.by": "Tillagd av",
  "error.connection.lost.body": "Vi väntar här medan du återansluter.",
  "error.connection.lost.title": "Det verkar som att du har tappat anslutningen.",
  "error.connection.recovered.action": "Ladda om innehållet",
  "error.connection.recovered.title": "Ansluten igen",
  "error.notfound.title": "Tusan, vi kan inte hitta sidan.",
  "error.recovery.body": "Dina ändringar är säkra. Uppdatera sidan och försök igen.",
  "error.recovery.title": "Något gick fel när redigeraren lästes in",
  "error.server-error.body": "Försök igen senare.",
  "error.server-error.title": "Något har gått fel.",
  "error.session.expired.body": "Vi lovar att hålla bättre uppsikt nästa gång.",
  "error.session.expired.title": "Det verkar som att vi har tappat din session.",
  "excel.file": "Microsoft Excel-kalkylblad",
  "excel.macro.file": "Microsoft Excel-kalkylblad med makrostöd",
  "excel.template.file": "Microsoft Excel-mall",
  "excel97.file": "Microsoft Excel-kalkylblad",
  "excel97.template.file": "Microsoft Excel 97-mall",
  "existing.blogpost.placeholder": "Blogginläggstitel",
  "expand-macro.default-title": "Klicka här för att expandera ...",
  "expand.name": "Utöka",
  "fabric.editor.announcement.datednotice.main": "Den {0} kommer du att uppgraderas till vår nya redigeringsupplevelse.",
  "fabric.editor.announcement.dismiss": "Avfärda",
  "fabric.editor.announcement.greeting": "Hej {0}!",
  "fabric.editor.announcement.initialnotice.main": "Om några veckor kommer sättet man skapar innehåll på Confluence att förändras.",
  "fabric.editor.announcement.link.action": "Se vad som har förändrats och vilka nya funktioner du kommer att få.",
  "fabric.editor.announcement.rollbacknotice.action": "Läs meddelandet om hur man återställer befintliga sidor till den gamla upplevelsen.",
  "fabric.editor.announcement.rollbacknotice.main": "Nyligen uppdaterades dina sidor av misstag till den nya redigeringsupplevelsen. Vi har nu återställt det.",
  "fabric.editor.announcement.tryit.action": "Prova det på en ny sida.",
  "fabric.editor.announcement.tryitnotice.main": "Den nya redigeringsupplevelsen ger dig snyggare sidor och nya funktioner som live-makron.",
  "fabric.editor.changeboarding.banner.action": "Se vilka nya saker du kan göra.",
  "fabric.editor.changeboarding.banner.dismiss": "Avfärda",
  "fabric.editor.changeboarding.banner.main": "Hej {0}! Vi håller på att göra en del förändringar som kommer att hjälpa dig att skapa innehåll som ser bättre ut och är lättare att läsa.",
  "fabric.editor.page.removed.description": "Uppdatera nu.",
  "fabric.editor.page.removed.title": "Sidan har nyligen arkiverats eller tagits bort",
  "fabric.editor.permission.removed.description": "Behörigheterna för den här sidan har ändrats. Kontakta en administratör om du vill ha hjälp.",
  "fabric.editor.permission.removed.title": "Vi kan inte visa den här sidan",
  "fabric.full.width.help.center.dialog.title": "New! Width control",
  "fabric.full.width.help.center.pageElement.details": "<p>Expanderar <strong>alla sidelement</strong> vågrätt, vilket resulterar i färre vita ytor. Växlingsknappen återställer även sidinnehållet till fast bredd.</p>",
  "fabric.full.width.help.center.pageElement.title": "Full-width page toggle",
  "fabric.full.width.help.center.tableElement.details": "<p>Kontrollera bredden på <strong>varje kolumn, varje tabell</strong> och de flesta <strong>makron</strong> med hjälp av alternativen för bred eller helbredd. Du kan även ange att vissa element ska ha kvar fast bredd.</p>",
  "fabric.full.width.help.center.tableElement.title": "Växlingsknapp för individuella element",
  "fabric.help.center.columns.details": "<p>Lägg till en <strong>kolumn</strong> på din sida och använd den <strong>flytande menyn</strong> för att växla mellan konfigurationer med 2 eller 3 kolumner.</p>",
  "fabric.help.center.columns.title": "Kolumner",
  "fabric.help.center.dialog.title": "Lär dig grunderna",
  "fabric.help.center.imageDisplay.details": "<p>Markera en bild och dra sedan <strong>handtagen</strong> för att ändra storlek eller använd den <strong>flytande menyn</strong> för att ändra dess justering.</p>",
  "fabric.help.center.imageDisplay.title": "Bildvisning",
  "fabric.help.center.layouts.details": "<p>Använd <kbd>←</kbd> <kbd>→</kbd> för att ändra layouten för kolumner, tabeller och makron.</p><p>Välj mellan en <strong>fixerad bredd</strong> som är den samma på alla skärmar, <strong>full bredd</strong> som expanderar och fyller utrymmet eller en mitt emellan <strong>bred</strong> inställning.</p>",
  "fabric.help.center.layouts.title": "Layouter",
  "fabric.help.center.menuitem.title": "Guide",
  "fabric.help.center.slashCommands.details": "<p>Skriv <kbd>/</kbd> för att öppna en meny och infoga innehåll som <strong>tabeller</strong>, <strong>makron</strong> och <strong>datum</strong> på din sida.</p>",
  "fabric.help.center.slashCommands.title": "Snedstreckskommandon",
  "fabric.help.center.spotlight.body": "Kom tillbaka hit till guiden när som helst.",
  "fabric.help.center.spotlight.header": "Behöver du friska upp minnet?",
  "fabric.help.center.tableManipulation.details": "<p>Redigera eller ändra format på tabeller via menyerna <strong>tabellkantlinjer</strong>, <strong>listruta</strong> och <strong>flytande</strong>.</p>",
  "fabric.help.center.tableManipulation.title": "Tabellmanipulering",
  "fabric.help.center.templates.details": "<p>Hitta en mall som uppfyller dina behov. Öppna panelen igen från menyn Fler åtgärder (•••) när den är stängd.</p>",
  "fabric.help.center.templates.title": "Mallar",
  "fabric.help.center.title": "Lär dig grunderna",
  "fabric.insert.external.image": "Infoga bild från webben",
  "fabric.template.can.not.parse.content": "Vi kan inte öppna mallen eftersom den innehåller trasiga element eller element som inte stöds.",
  "fabric.template.can.not.save.error.title": "Kan inte spara ändringar",
  "fabric.template.can.not.save.error.title.duplicate": " Det finns redan en mall med namnet <strong>{0}</strong>. Om du vill spara mallen måste du ge den ett annat namn.",
  "fabric.template.found.invalid.node": "Flera mallvariabler som har samma namn \"{variableNames}\" men olika parametrar.",
  "favourite.spaces": "Mina utrymmen",
  "feedback.flag.thanks.description": "Din feedback hjälper oss skapa bättre upplevelser.",
  "feedback.flag.thanks.title": "Tack!",
  "filter.name": "Filter",
  "gif.file": "GIF-fil",
  "global.spaces": "Webbplatsens utrymmen",
  "globaladminbilling.label": "Fakturering",
  "header.or.footer.unsupported.macros.list": "Följande makron stöds för närvarande inte i {0}:",
  "header.or.footer.unsupported.macros.title": "Makron som inte stöds",
  "heading.comment": "Ändrad av",
  "heading.createpage": "Skapa sida",
  "heading.createpage.sentence": "Skapa sida",
  "heading.operations": "Åtgärder",
  "heading.version.date": "Publicerad",
  "heading.version.number": "Version",
  "help.name": "Hjälp",
  "help.us.improve": "Hjälp oss att bli bättre",
  "hipchat.presence.status.available": "Tillgänglig",
  "hipchat.presence.status.away": "Frånvarande",
  "hipchat.presence.status.dnd": "Stör ej",
  "hipchat.presence.status.offline": "Offline",
  "html.file": "HTML-fil",
  "icon.tooltip.remove": "Ta bort",
  "icon.tooltip.undo": "Ångra",
  "image.browser.imageurl.label": "Bildwebbadress",
  "image.height": "Höjd",
  "image.properties.dialog.cancel": "Avbryt",
  "image.properties.dialog.heading": "Bildegenskaper",
  "image.properties.trigger": "Egenskaper",
  "image.properties.trigger.tooltip": "Ange ytterligare bildegenskaper",
  "inline.comment.sidebar.navigate.next.description": "Nästa inlinekommentar",
  "inline.comment.sidebar.navigate.previous.description": "Föregående inlinekommentar",
  "inline.comments.GROW-1507.dialog.close.label": "Stäng",
  "inline.comments.GROW-1507.dialog.content": "Känner du till inlinekommentarer?<br>Du kan använda dem för granskning och lägga till dem i en specifik del av dokumentet.",
  "inline.comments.GROW-1507.dialog.header": "Inlinekommentarer",
  "inline.comments.GROW-1507.dialog.ok.label": "Okej, jag förstår",
  "inline.comments.GROW-1507.dialog.showme.label": "Visa mig",
  "inline.comments.GROW-1507.dialog.title": "KOMMENTARSTIPS",
  "inline.comments.batch.email.view": "Visa kommentar",
  "inline.comments.create.placeholder": "skriv en kommentar…",
  "inline.comments.create.reply.placeholder": "Svar",
  "inline.comments.date.friendly.about.one.hour.ago": "1 timme sedan",
  "inline.comments.date.friendly.about.x.days.ago": "{0} dagar sedan",
  "inline.comments.date.friendly.about.x.hours.ago": "{0} timmar sedan",
  "inline.comments.date.friendly.formatted": "{0}",
  "inline.comments.date.friendly.now": "alldeles nyss",
  "inline.comments.date.friendly.one.min.ago": "1 minut sedan",
  "inline.comments.date.friendly.x.mins.ago": "{0, plural, one {{0} minut sedan} other {{0} minuter sedan}}",
  "inline.comments.date.friendly.yesterday": "igår",
  "inline.comments.delete.confirmation.message": "Är du säker på att du vill ta bort kommentaren?",
  "inline.comments.delete.permission": "Du har inte behörighet att ta bort den här kommentaren.",
  "inline.comments.delete.reply.confirmation.message": "Är du säker på att du vill ta bort det här svaret?",
  "inline.comments.delete.with.reply": "Du kan inte radera inlinekommentarer i trådar med svar.",
  "inline.comments.delete.with.reply.need.reload": "Du kan inte radera den här kommentaren eftersom det finns svar på den här tråden. Läs in på nytt för att visa dem.",
  "inline.comments.edit.permission": "Du saknar behörighet att redigera den här kommentaren.",
  "inline.comments.editor.lost": "Din kommentar kommer att gå förlorad.",
  "inline.comments.editor.timeout": "Redigeraren lästes inte in korrekt. {0}Läs in sidan på nytt{1} för att försöka igen.",
  "inline.comments.expand.replies": "{0} fler svar",
  "inline.comments.fabric.editor.error.cannot.be.empty": "Kommentaren är tom. Lägg till feedback och klicka på Spara.",
  "inline.comments.fabric.editor.error.captcha.check.failed": "Fel vid Captcha-kontroll",
  "inline.comments.fabric.editor.error.captcha.check.succeeded": "Captcha-kontroll klar",
  "inline.comments.fabric.editor.error.create.not.permitted": "Enligt inställningarna är du inte behörig att skapa kommentarer. Hör med administratören om du behöver kunna det.",
  "inline.comments.fabric.editor.error.delete.not.permitted": "Enligt inställningarna är du inte behörig att ta bort kommentarer. Hör med administratören om du behöver kunna det.",
  "inline.comments.fabric.editor.error.edit.not.permitted": "Enligt inställningarna är du inte behörig att redigera kommentarer. Hör med administratören om du behöver kunna det.",
  "inline.comments.fabric.editor.error.invalid.selection": "Det går inte att skapa kommentaren. Skapa markeringen med mer unik text för att göra urvalet mer avgränsat, så att din kommentar mappas till rätt innehåll.",
  "inline.comments.fabric.editor.error.resolve.not.permitted": "Enligt inställningarna är du inte behörig att lösa kommentarer. Hör med administratören om du behöver kunna det.",
  "inline.comments.fabric.editor.error.unexpected": "Något gick fel när den här kommentaren skulle sparas. Stäng kommentaren eller uppdatera sidan, och försök att lägga till kommentaren igen.",
  "inline.comments.fabric.editor.error.view.not.permitted": "Enligt inställningarna är du inte behörig att visa kommentaren. Hör med administratören om du behöver kunna det.",
  "inline.comments.fabric.inline.button.cancel": "Avbryt",
  "inline.comments.fabric.inline.button.save": "Spara",
  "inline.comments.fabric.sidebar.loading.error": "Ett fel inträffade. Stäng kommentarsfönstret och försök igen",
  "inline.comments.likes.error": "Gillamarkeringen kan inte uppdateras.",
  "inline.comments.likes.like": "Gilla",
  "inline.comments.likes.unlike": "Sluta gilla",
  "inline.comments.navigation.index.of": "{0} av {1}",
  "inline.comments.notification.email.reopened": "Öppnades på nytt",
  "inline.comments.notification.email.resolved": "Löst",
  "inline.comments.notification.email.view": "Visa kommentar",
  "inline.comments.resolve.permission": "Du saknar behörighet att lösa den här kommentaren.",
  "inline.comments.resolved.dangling.message": "Löst eftersom texten raderades av {0} {1}",
  "inline.comments.resolved.dialog.empty": "Det finns inga lösta kommentarer på den här sidan.",
  "inline.comments.resolved.dialog.message": "Den här kommentaren är borta för alltid! Du kan se lösta kommentarer när som helst.",
  "inline.comments.resolved.dialog.show.me": "Visa mig",
  "inline.comments.resolved.discovery.button.dismiss": "Okej, jag förstår",
  "inline.comments.resolved.discovery.content": "Har du något mer att säga? Du kan öppna kommentarer på nytt för att fortsätta diskussionen.",
  "inline.comments.resolved.menu.show.replies": "{0} svar",
  "inline.comments.resolved.menu.show.reply": "{0} svar",
  "inline.comments.resolved.menu.unresolve": "Återuppta",
  "inline.comments.resolved.message": "Löst {0} {1}",
  "inline.comments.resolved.view.menu": "Lösta kommentarer",
  "inline.comments.server.edit.error": "Vi kan inte spara din ändring. Kommentaren kan ha raderats.",
  "inline.comments.server.error": "Det gick att slutföra din begäran.",
  "inline.comments.server.error.edit.comment": "Vi kan inte redigera den här kommentaren. Kommentaren kan ha raderats.",
  "inline.comments.server.error.edit.reply": "Vi kan inte redigera det här svaret. Det här svaret kan ha raderats.",
  "inline.comments.sidebar.cancel": "Avbryt",
  "inline.comments.sidebar.close": "Stäng",
  "inline.comments.sidebar.comment.empty": "Du kan inte spara en tom kommentar.",
  "inline.comments.sidebar.delete": "Ta bort",
  "inline.comments.sidebar.deleted": "Borttagen",
  "inline.comments.sidebar.discard": "Kassera",
  "inline.comments.sidebar.edit": "Redigera",
  "inline.comments.sidebar.error.create.comment": "Vi kan inte lägga till din inlinekommentar. Valet du markerat kan innehålla ett makro eller ett användaromnämnande. Testa att markera oformaterad text.",
  "inline.comments.sidebar.error.delete.generic": "Fel vid borttagning av kommentar. Kontrollera Confluence-loggarna avseende fel.",
  "inline.comments.sidebar.error.delete.unauthorised": "Du har inte behörighet att ta bort den här kommentaren.",
  "inline.comments.sidebar.error.empty": "Ange din kommentar.",
  "inline.comments.sidebar.error.save.comment": "Det gick inte att spara kommentaren",
  "inline.comments.sidebar.error.save.reply": "Det gick inte att spara svaret",
  "inline.comments.sidebar.error.stale": "Sidoinnehållet har förfallit, {0}uppdatera{1} och försök igen.",
  "inline.comments.sidebar.like": "Gilla",
  "inline.comments.sidebar.pagecomment.success": "Sidokommentaren skapas",
  "inline.comments.sidebar.reply": "Svar",
  "inline.comments.sidebar.resolve": "Åtgärda",
  "inline.comments.sidebar.resolved": "Löst",
  "inline.comments.sidebar.save": "Spara",
  "inline.comments.sidebar.saved": "Sparad",
  "inline.comments.sidebar.shortcuts.close.description": "Stäng inlinekommentar",
  "inline.comments.sidebar.show.resolved.comment": "Visa lösta kommentarer",
  "inline.comments.sidebar.tooltip.close.description": "Stäng sidofält (])",
  "inline.comments.sidebar.tooltip.next.ic.description": "Nästa kommentar (N)",
  "inline.comments.sidebar.tooltip.previous.ic.description": "Tidigare kommentar (P)",
  "inline.comments.templates.create.a.comment": "<strong>kommenterade</strong> på en sida",
  "inline.comments.templates.resolved.a.comment": "<strong>löste</strong> en kommentar",
  "inline.comments.templates.resolved.a.comment.dangling": "raderad text hänvisas till med en inlinekommentar, så kommentaren <strong>löstes</strong>",
  "inline.comments.templates.unresolved.a.comment": "<strong>öppnade</strong> en kommentar på nytt",
  "inline.comments.unresolved.message": "Öppnad på nytt av {0} {1}",
  "jar.file": "Java-arkiv",
  "java.file": "Java-källkod",
  "jpeg.file": "JPEG-fil",
  "js.file": "JavaScript-fil",
  "keyboard.shortcut.alt": "Alt",
  "keyboard.shortcut.ctrl": "Ctrl",
  "keyboard.shortcut.option": "Option",
  "keyboard.shortcut.shift": "Skift",
  "label.contains.invalid.chars": "<b>{0}</b> innehåller ogiltiga tecken ({1}).",
  "label.name.is.too.long": "Etikettsnamn måste vara kortare än {0} tecken.",
  "labels.dialog.shortcut.tip": "Shortcut tip: I sidvyn öppnas också den här dialogrutan om du trycker på <b>{shortcut}</b>",
  "labels.none": "In etiketter",
  "labels.title": "Etiketter",
  "last.saved": "Senast sparad",
  "likes.bethefirst": "Var den förste att gilla detta",
  "likes.follow": "Följ",
  "likes.following": "Följer",
  "likes.like": "Gilla",
  "likes.peoplewholikethis": "Personer som gillar detta",
  "likes.summary.1.non-promoted": "{0} gillar detta",
  "likes.summary.1.promoted": "{0} gillar detta",
  "likes.summary.1.promoted.1.non-promoted": "{0} och {1} gillar detta",
  "likes.summary.2.promoted": "{0} och {1} gillar detta",
  "likes.summary.2.promoted.1.non-promoted": "{0}, {1} och {2} gillar detta",
  "likes.summary.3.promoted": "{0}, {1} och {2} gillar detta",
  "likes.summary.3.promoted.1.non-promoted": "{0}, {1}, {2} och {3} gillar detta",
  "likes.summary.you": "Du gillar detta",
  "likes.summary.you.1.non-promoted": "Du och {0} gillar detta",
  "likes.summary.you.1.promoted": "Du och {0} gillar detta",
  "likes.summary.you.1.promoted.1.non-promoted": "Du, {0} och {1} gillar detta",
  "likes.summary.you.2.promoted": "Du, {0} och {1} gillar detta",
  "likes.summary.you.2.promoted.1.non-promoted": "Du, {0}, {1} och {2} gillar detta",
  "likes.summary.you.3.promoted": "Du, {0}, {1} och {2} gillar detta",
  "likes.summary.you.3.promoted.1.non-promoted": "Du, {0}, {1}, {2} och {3} gillar detta",
  "likes.unlike": "Sluta gilla",
  "limited.mode.existing.editor.body": "Kollaborativ redigering är offline just nu, och {0} redigerar sidan. Försök igen om några minuter.",
  "link.browser.advanced.desc1": "Skriv in den önskade sidtiteln för att infoga en länk till en ny sida.",
  "link.browser.advanced.desc2": "För att infoga en ankarlänk, skriv #ankarnamn.",
  "link.browser.advanced.error.internal.error": "Ett internt serverfel har inträffat",
  "link.browser.advanced.error.not.link": "Angiven markup är inte giltig länk-markup",
  "link.browser.advanced.error.unknown.shortcut": "{0} känns inte igen som en genväg",
  "link.browser.advanced.error.unknown.space": "{0} känns inte igen som ett utrymme",
  "link.browser.advanced.title": "Här kan du infoga en länk på sidan med hjälp av <a href=\"{0}\" target=\"_blank\">wiki-markup</a>.",
  "link.browser.autocomplete.hint": "Tips: skriv \"[\" i editorn för att visa en lista med föreslagna sidor och infoga en länk.",
  "link.browser.cancel.button": "Avbryt",
  "link.browser.edit.button": "Infoga",
  "link.browser.edit.title": "Redigera länk",
  "link.browser.file.attach": "Ladda upp en fil",
  "link.browser.file.attach.desc": "Länka till en fil som är bifogad till denna sida eller bifoga en ny.",
  "link.browser.file.attach.upload.in.progress": "Uppladdning pågår",
  "link.browser.file.browse.button": "Bläddra",
  "link.browser.files.none": "Det finns inga filer på denna sida.",
  "link.browser.insert.button": "Infoga",
  "link.browser.insert.title": "Infoga länk",
  "link.browser.link": "Länk",
  "link.browser.link.alias": "Länktext",
  "link.browser.link.image.label": "Länka bild",
  "link.browser.location": "Länkplats",
  "link.browser.recently.viewed.load.error": "Ett fel inträffade vid laddning av nyligen visade sidor",
  "link.browser.recently.viewed.none": "Du har inget nyligen visat innehåll.",
  "link.browser.search": "Sök",
  "link.browser.search.for": "Sök efter",
  "link.browser.search.invalid": "Ogiltiga söktermer",
  "link.browser.search.results.load.error": "Ett fel påträffades under sökningen",
  "link.browser.search.results.none": "Inga sökresultat hittades.",
  "link.browser.space.all": "Allt innehåll",
  "link.browser.tab.name.advanced": "Avancerat",
  "link.browser.tab.name.files": "Filer",
  "link.browser.tab.name.recently.viewed": "Nyligen visade",
  "link.browser.tab.name.search": "Sök",
  "link.browser.tab.name.weblinks": "Webblänk",
  "link.browser.table.file.comment": "Kommentar",
  "link.browser.table.file.name": "Namn",
  "link.browser.table.file.size": "Storlek",
  "link.browser.table.last.modified": "Senast ändrad",
  "link.browser.table.space": "Utrymme",
  "link.browser.table.title": "Titel",
  "link.browser.web.link": "URL",
  "link.browser.web.link.desc": "Webb-, e-post eller annan internetadress",
  "link.browser.web.link.label": "Adress",
  "location.name": "Plats",
  "login.button": "Logga in",
  "look.and.feel": "Utseende och känsla",
  "marketplace.link.name": "Marketplace-appar",
  "more.word.action": "Fler åtgärder",
  "more.word.capitalised": "Mer",
  "moveblogpost.already.exists.in.target.space": "Ett annat blogginlägg med samma titel och datum existerar redan i det valda utrymmet.",
  "moveblogpost.source.notfound": "Det ursprungliga blogginlägget hittades inte.",
  "moveblogpost.target.space.notfound": "Målplatsen hittades inte",
  "moveblogpost.target.space.same.as.origin": "Du kan inte flytta ett blogginlägg till den plats det redan är i.",
  "multimedia.file": "Multimedia-fil",
  "my.drafts.mainBanner": "Fånga idéer, snabbt",
  "my.drafts.subBanner": "Skapa en sida och skriv ner dina idéer. Om du inte är redo att publicera än kan du bara stänga sidan. Vi sparar automatiskt ett utkast så att du kan fortsätta när du vill. ",
  "my.spaces.tooltip.add": "Lägg till i Mina utrymmen",
  "my.spaces.tooltip.remove": "Ta bort från Mina utrymmen",
  "name.word": "Namn",
  "nav.controller.activity": "Aktivitet",
  "nav.controller.activity.feed": "Aktivitetsfeed",
  "nav.controller.all.spaces": "Utrymmen",
  "nav.controller.discover": "Upptäck",
  "nav.controller.my.spaces": "Mina utrymmen",
  "nav.controller.my.spaces.anchor": "Alla",
  "nav.controller.my.spaces.blank": "Ha dina mest användbara utrymmen nära till hands. Klicka på stjärnikonen bredvid önskat utrymme för att få det att visas här.",
  "nav.controller.my.spaces.blank.callToAction": "Hitta utrymmen",
  "nav.controller.projects": "Projekt",
  "nav.controller.recent": "Senaste sidorna",
  "nav.controller.your.work": "Ditt arbete",
  "navigation.app.switcher.apps": "Appar",
  "navigation.app.switcher.dont.show.again": "Visa inte igen.",
  "navigation.app.switcher.edit": "Redigera",
  "navigation.app.switcher.error-message": "Ett fel uppstod när applikationslänkar hämtades.",
  "navigation.app.switcher.home.description": "Hem",
  "navigation.app.switcher.img.alt": "Applikationsväxlare",
  "navigation.app.switcher.loading": "Laddar ...",
  "navigation.app.switcher.recent": "Senaste",
  "navigation.app.switcher.recent-containers-confluence-space": "Utrymme",
  "navigation.app.switcher.recent-containers-jira-project": "Projekt",
  "navigation.app.switcher.try.other.apps": "Testa andra appar",
  "navigation.app.switcher.use.confluence": "Använd Confluence",
  "navigation.app.switcher.use.jira": "Använd Jira",
  "navigation.label-for-bell": "Meddelanden",
  "navigation.label-for-global-people-icon": "Personkatalog",
  "navigation.notification-drawer-title": "Meddelanden för hem",
  "navigation.people-drawer-title": "Personkatalog",
  "navlink.edit": "{0}R{1}edigera",
  "network.page": "Nätverkssida",
  "no.drafts.found": "Inga utkast hittades.",
  "no.matches.mainBanner": "Vi kan inte hitta något för",
  "no.name": "Nej",
  "no.permission": "Ingen tillåtelse",
  "no.spaces.found": "Inga utrymmen hittades.",
  "not.watching.anything": "Du bevakar inte någonting.",
  "notification.start": "Börja bevaka",
  "notification.stop": "Sluta bevaka",
  "notifications.batch.inline.comment.created.section.header": "{0, choice, 1#Inlinekommentar|1<Inlinekommentarer}",
  "notifications.batch.inline.comment.new.lozenge": "ny",
  "notifications.batch.inline.comment.reopened.lozenge": "öppnade på nytt",
  "notifications.batch.inline.comment.resolved": "$user $lozenge en kommentar",
  "notifications.batch.inline.comment.resolved.lozenge": "löste",
  "notifications.preferences.desc": "Du kan ställa in dina alternativ för e-postaviseringar på sidan <a href=\"viewmyemailsettings.action\">e-postinställningar</a>.",
  "onboarding-choose-a-space.description": "Välj ett av ditt teams nuvarande utrymmen. Du kommer att kunna skapa fler utrymmen senare.",
  "onboarding-choose-a-space.title": "Välj ett utrymme att arbeta på",
  "onboarding.choose-a-space.backBtn": "Tillbaka",
  "onboarding.choose-a-space.nextBtn": "Nästa",
  "onboarding.choose-a-space.selectLabel": "Platsnamn",
  "onboarding.choose-a-space.selectPlaceholder": "Välj utrymmets namn",
  "onboarding.create-a-space.backBtn": "Tillbaka",
  "onboarding.create-a-space.description": "Starta med att skapa ett utrymme för ditt team eller projekt. Du kommer att kunna skapa fler utrymmen senare.",
  "onboarding.create-a-space.inputTextLabel": "Namn",
  "onboarding.create-a-space.inputTextPlaceholder": "Kristall Juvel",
  "onboarding.create-a-space.invalidMessage": "Utrymmesnamn måste vara minst en bokstav eller siffra långa.",
  "onboarding.create-a-space.nextBtn": "Nästa",
  "onboarding.create-a-space.title": "Skapa ett utrymme att arbeta på",
  "onboarding.dialog.existing-user.cancel": "Visa inte tips",
  "onboarding.dialog.existing-user.confirm": "Låt oss börja",
  "onboarding.dialog.existing-user.content": "Vi har flyttat om några saker för att ge dig en bättre dashboard-upplevelse och satt på några tips för att hjälpa dig att komma igång.",
  "onboarding.dialog.existing-user.title": "Välkommen till din nya dashboard!",
  "onboarding.dialog.new-user.cancel": "Visa inte tips",
  "onboarding.dialog.new-user.confirm": "Låt oss börja",
  "onboarding.dialog.new-user.content": "Dashboard är startsidan som häjlper dig att navigera i Confluence.<br/>Vi har aktiverat några tips för att hjälpa dig komma igång",
  "onboarding.dialog.new-user.title": "Välkommen till dashboarden!",
  "onboarding.navigation.blog.tip.blog.list.byline": "Tryck på hem för att växla till en lista över sidor eller annat innehåll.",
  "onboarding.navigation.blog.tip.blog.list.heading": "Din blogglista finns fortfarande här",
  "onboarding.navigation.dont.show": "Visa inte fler tips",
  "onboarding.navigation.global.sidebar.byline": "Så oavsett var i Confluence du är finns de viktiga sakerna bara ett klick bort.",
  "onboarding.navigation.global.sidebar.heading": "Detta sidofält är nu universellt",
  "onboarding.navigation.ok": "Okej, jag förstår",
  "onboarding.navigation.page.tip.page.tree.byline": "Tryck på hem för att växla till en lista över bloggar eller annat innehåll.",
  "onboarding.navigation.page.tip.page.tree.heading": "Ditt sidträd finns fortfarande här",
  "onboarding.navigation.space.tip.space.tabs.byline": "Hemsidan för ditt utrymme är nu översikten, och dina sidor, blogginlägg och annat innehåll har alla sin egen flik.",
  "onboarding.navigation.space.tip.space.tabs.heading": "Ditt innehåll är nu organiserat i flikar",
  "onboarding.tooltip.actions.done": "Jag förstår!",
  "onboarding.tooltip.actions.next": "Nästa",
  "onboarding.tooltip.actions.skip": "Hoppa över tips",
  "onboarding.tooltip.existing-user.favourite-spaces.content": "Gå direkt till dina favoritutrymmen eller besök listan över alla utrymmen.",
  "onboarding.tooltip.existing-user.favourite-spaces.title": "Favoritutrymmen vid dina fingerspetsar",
  "onboarding.tooltip.existing-user.sidebar.content": "Hitta nya sidor och hitta tillbaka till ditt senaste arbete från ditt nya smidiga sidofält.",
  "onboarding.tooltip.existing-user.sidebar.title": "Upptäck med med sidofältet",
  "onboarding.tooltip.new-user.favourite-spaces.content": "Gå direkt till dina favoritutrymmen eller visa listan över alla utrymmen.",
  "onboarding.tooltip.new-user.favourite-spaces.title": "Dina favoritutrymmen nära till hands",
  "onboarding.tooltip.new-user.sidebar.content": "Hitta nya sidor och återvänd till det du nyligen arbetat på från sidofältet.",
  "onboarding.tooltip.new-user.sidebar.title": "Upptäck med med sidofältet",
  "onboarding.tooltip.saved-for-later.content": "Dina favoriter hittar du nu under sitt nya namn - Sparat till senare.",
  "onboarding.tooltip.saved-for-later.title": "Hej då Favoriter, Välkommen Sparat till senare",
  "onboarding.who-is-on-your-team.addMoreBtn": "+ Lägg till fler e-postadresser",
  "onboarding.who-is-on-your-team.description": "Confluence fungerar bättre när teammedlemmar skapar, diskuterar och samarbetar med dig.",
  "onboarding.who-is-on-your-team.emailPlaceholder": "Lägg till e-postadress",
  "onboarding.who-is-on-your-team.enableDRS": "Låt vem som helst som har en verifierad e-postadress från {domain} gå med i din webbplats (vi kommer att meddela dig när det sker).",
  "onboarding.who-is-on-your-team.enableOpenInvite": "Låt användare bjuda in andra personer till din sajt.",
  "onboarding.who-is-on-your-team.form.invalid.email": "Ange en giltig e-postadress",
  "onboarding.who-is-on-your-team.nextBtn": "Nästa",
  "onboarding.who-is-on-your-team.title": "Vem är med i ditt team?",
  "only.personal.labels.permitted": "Du har endast tillåtelse att lägga till personliga etiketter på denna sida.",
  "org.randombits.confluence.toc.toc.label": "Innehållsförteckning",
  "page.already.exists": "En annan sida med samma titel existerar redan på det valda utrymmet.",
  "page.already.exists.inspace": "Sidan ”'{'0'}'” finns redan i utrymmet '{'1'}'. Du måste ändra sidans rubrik innan du flyttar den.",
  "page.change": "Vad ändrade du?",
  "page.comments.saved.dialog.message": "Din kommentar har sparats som en sidokommentar.",
  "page.comments.sidebar.warning": "Vi kan inte lägga till en inlinekommentar i det här innehållet. Vi lägger till den som en sidokommentar i stället.",
  "page.descendent.already.exists": "En undersida har samma titel som en annan sida i det valda utrymmet.",
  "page.permissions.menu.item.title": "Restriktioner",
  "page.permissions.menu.item.title.tooltip": "Redigera restriktioner",
  "page.tree.blankExperience.mainBanner": "Här finns inget utom potential.",
  "page.tree.blankExperience.subBanner": "Sätt igång att skapa några mötesanteckningar, produktspecifikationer, instruktionsartiklar eller annat innehåll för att fylla detta utrymme.",
  "page.watch.instruction": "För att bevaka en sida eller ett blogginlägg: öppna ‘Verktygs’-menyn och klicka på ‘Bevaka’.",
  "page.watches": "Sidor om bevakas",
  "page.word": "Sida",
  "pages.navigation.discovery.body.html": "Klicka på <strong>Sidor</strong> för att visa sidträdet och bläddra bland sidor i det här utrymmet.",
  "pages.navigation.discovery.header": "Sidträdet bor här nu",
  "pages.show.all": "Visa alla sidor",
  "pages.word": "Sidor",
  "pagetree.dragndrop.failed.action.visitsupport": "Gå till Atlassian Support",
  "pagetree.dragndrop.failed.description": "Uppdatera sidan och försök igen. Kontakta oss via länken nedan om problemet kvarstår.",
  "pagetree.dragndrop.failed.title": "Något gick fel.",
  "pagetree.failed.load.content": "Sidträd kunde inte läsas in",
  "pagetree.failed.load.tooltip": "Håll ut, vi arbetar på att åtgärda problemet.",
  "parent.page.invalid.for.space": "Det finns ingen sida med titeln <b>{0}</b> på utrymmet <b>{1}</b>.",
  "parent.page.name": "Över",
  "pdf.file": "PDF-fil",
  "people.directory.name": "Personer",
  "period.lastSevenDays": "Under den senaste veckan",
  "period.lastThirtyDays": "Under den senaste månaden",
  "period.older": "Mer än en månad sedan",
  "period.today": "Idag",
  "period.yesterday": "Igår",
  "permission.owner.not.in.group": "Du kan endast bevilja sidrättigheter till grupper du är medlem i",
  "permission.owner.not.set": "Du måste välja en ägare för behörigheten",
  "permissions.comment": "Precisera vem som kan visa och redigera sidan.  Du kan begränsa dessa rättigheter till dig själv eller en grupp användare.",
  "permissions.edit.title": "Redigera",
  "permissions.select.nopermissions": "Ej angivet",
  "permissions.view.title": "Visa",
  "person.follow": "Följ",
  "person.follow.stop": "Sluta följa",
  "personal.spaces": "Personliga utrymmen",
  "placeholder.placeholdertext.label": "Platshållartext",
  "placeholder.replacementtext.label": "Ersättningstext",
  "please.enter.a.label": "Vänligen ange en etikett.",
  "png.file": "PNG-fil",
  "popular.stream.mainBanner": "Det händer inte så mycket ... Än",
  "popular.stream.subBanner": "Det är ganska lugnt nu, men så snart ditt team börjar skapa kommer de mest populära sidorna och filerna att visas här.",
  "popular.stream.subBanner2": "Låt oss sätta igång!",
  "popular.stream.title": "Populärt",
  "posted.word": "Upplagd",
  "powerpoint.file": "Microsoft Powerpoint-presentation",
  "powerpoint.macro.file": "Microsoft Powerpoint-presentation med makrostöd",
  "powerpoint.slideshow.file": "Microsoft Powerpoint-bildspel",
  "powerpoint.template.file": "Microsoft Powerpoint-mall",
  "powerpoint97.file": "Microsoft Powerpoint 97-bildspel",
  "powerpoint97.template.file": "Microsoft Powerpoint 97-mall",
  "product.name": "Confluence",
  "profile.page": "Profilsida",
  "property.panel.macro.display.inline": "Visa inline",
  "property.panel.macro.display.newline": "Visa på ny rad",
  "property.panel.macro.edit": "Redigera",
  "property.panel.macro.remove": "Ta bort",
  "property.panel.textplaceholder.display.default": "Text",
  "property.panel.textplaceholder.display.default.tooltip": "Instruktionstexten ersätts med tomt innehåll när någon skriver.",
  "property.panel.textplaceholder.display.mention": "Användaromnämnande",
  "property.panel.textplaceholder.display.mention.tooltip": "Instruktionstexten ersätts med föreslagna personer när någon skriver.",
  "property.panel.textplaceholder.remove": "Ta bort",
  "property.panel.variable.display.list": "Lista",
  "property.panel.variable.display.list.tooltip": "Rullgardinslista",
  "property.panel.variable.display.string": "Text",
  "property.panel.variable.display.string.tooltip": "Inmatningsfält för enkelradig text.",
  "property.panel.variable.display.textarea": "Flerradig text",
  "property.panel.variable.display.textarea.tooltip": "Inmatningsfält för flerradig text.",
  "property.panel.variable.list.values.tooltip": "Ange varje post för listan, separerade med ett kommatecken.",
  "property.panel.variable.textarea.columns.tooltip": "Antal kolumner att visa för fältet.",
  "property.panel.variable.textarea.rows.tooltip": "Antal rader att visa för fältet.",
  "quick.comment.placeholder.message": "Skriv en kommentar",
  "quick.reload.edit": "Nya sidoredigeringar",
  "quick.reload.edit.by": "av",
  "quick.reload.edit.more": "och {0} andra",
  "quick.reload.edit.one.more": "och 1 annan",
  "quick.reload.edits": "{0} nya redigeringar",
  "quick.reload.newcomments": "{0} nya kommentarer",
  "quick.reload.newpagecomment": "Ny kommentar",
  "quick.reload.reload": "Ladda om sidan",
  "recently-updated-content-list.commented.new": "Senaste kommentar {time}",
  "recently-updated-content-list.created.new": "Skapades {time}",
  "recently-updated-content-list.edited.new": "Uppdaterades {time}",
  "recently.viewed.mainBanner": "Dags att skriva historia",
  "recently.viewed.subBanner": "Du har inte besökt några sidor än, men när du gör det placerar vi dem här så att du snabbt kan komma tillbaka till dem.",
  "recently.viewed.subBanner2": "Gå till ett <b>utrymme</b> nu och se dig omkring.",
  "recently.viewed.title": "Nyligen besökta",
  "recently.worked.mainBanner": "Avsluta mästerverket",
  "recently.worked.subBanner": "Du har inte skapat eller redigerat något ännu, men när du gör det placerar vi det här så att det blir lätt att fortsätta där du slutade.",
  "recently.worked.subBanner2": "Gå nu och skapa dina alster.",
  "recently.worked.title": "Nyligen arbetade med",
  "remove.comment.confirmation.message": "Är du säker på att du vill radera kommentaren?",
  "remove.label": "Radera etikett",
  "resize.image.dialog.title": "Ändra storlek på bild",
  "restore.this.version": "Återställ",
  "result.grid.column.content.last.modified": "Senast ändrad",
  "resume.editing": "Fortsätt",
  "return.to.page.info": "Återgå till sidinformation",
  "satisfaction.survey.reaction.amazing": "Fantastiskt",
  "satisfaction.survey.reaction.bad": "Dåligt",
  "satisfaction.survey.reaction.great": "Utmärkt",
  "satisfaction.survey.reaction.okay": "Okej",
  "satisfaction.survey.reaction.terrible": "Förfärligt",
  "save.name": "Spara",
  "scheme.desc.custom": "Ett eget färgschema som kan redigeras.",
  "scheme.desc.global": "Det här färgschemat använder det globalt definierade färgschemat för utrymmet.",
  "scheme.title.custom": "Eget färgschema",
  "scheme.title.global": "Globalt färgschema",
  "search.drawer.recently.viewed": "Nyligen visade",
  "search.drawer.recently.viewed.spaces": "Senaste utrymmen",
  "search.name": "Sök",
  "settings.name": "Inställningar",
  "share.button.restriction.message.text": "Begränsningar på denna sida kan hindra personer från att se och redigera.",
  "share.button.text": "Dela",
  "show.more.blogposts": "Visa fler blogginlägg",
  "sidebar.avatar.picker.upload.error": "Ett fel inträffade när utrymmesinformationen uppdaterades",
  "sidebar.main.back.to.overview": "Tillbaka till översikt",
  "sidebar.main.back.to.space": "Tillbaka till utrymme",
  "sidebar.main.blog": "Blogg",
  "sidebar.main.quick.links": "Platsgenvägar",
  "sidebar.main.settings": "utrymmes inställningar",
  "sidebar.main.shortcuts": "Länkar",
  "sidebar.main.wiki": "Sidor",
  "site-settings.templates-and-blueprints.edit-button-label": "Redigera",
  "space.404.banner.title": "Hoppsan, du har hittat en död länk",
  "space.404.go.back": "Gå tillbaka till",
  "space.404.go.to": "Gå till",
  "space.404.home.page": "hemsida",
  "space.404.previous.page": "föregående sida",
  "space.create": "Skapa utrymme",
  "space.home.blog.blankExperience.mainBanner": "Har du något att dela?",
  "space.home.blog.blankExperience.subBanner": "Blogginlägg är ett fantastiskt sätt att dela meddelanden, statusrapporter eller andra viktiga nyheter med ditt team.",
  "space.home.overview.blankExperience.mainBanner": "Det här var lite pinsamt.",
  "space.home.overview.blankExperience.subBanner": "Detta utrymme har ingen hemsida så det finns inget att visa här. Vi tycker också det är ledsamt.",
  "space.home.overview.blankExperience.subBanner2": "Lägg till en hemsida för att piffa upp utrymmet, och använd den för att tala om för dina besökare vad utrymmet handlar om!",
  "space.not.exists": "Utrymmet du har angett existerar inte.",
  "space.personal.name": "Personligt utrymme",
  "space.set.space.home": "Ange utrymmets hem",
  "space.watch.instruction": "För att bevaka sidor eller blogginlägg på utrymmen, klicka på ‘Sidor’ eller ‘Blogg’ på utrymmets sidofält.",
  "space.watches": "Utrymmesbevakningar",
  "spaces.all": "Alla utrymmen",
  "spaces.lookandfeel.help": "Här kan du anpassa utseendet på detta Confluence-utrymme.",
  "spaces.lookandfeel.note": "<span class=\"errorMessage\">Observera:</span> <i>Alla ändringar som görs här gäller istället för standardfärgschemat och standard-dekoratörerna som systemadministratören har ställt in.</i>",
  "spaces.word": "Utrymmen",
  "starred.mainBanner": "Det finns inget att se här ... Än",
  "starred.spaces.tooltip.add": "Stjärnmärk det här utrymmet",
  "starred.spaces.tooltip.remove": "Ta bort stjärnmarkering av utrymmet",
  "starred.subBanner": "Tryck på <b>stjärnikonen</b> för att spara sidan till senare. Vi lägger den här så att du kan hitta den när du behöver den.",
  "starred.title": "Sparat till senare",
  "status.lozenge.draft": "Utkast",
  "status.lozenge.unpublished": "Opublicerade ändringar",
  "submit.name": "Skicka",
  "super-admin.banner.exit": "Sluta använda administratörsnyckel",
  "super-admin.banner.message": "Du använder administratörsåtkomst som ger dig tillfällig åtkomst till begränsat innehåll.",
  "switch.apps": "Växla appar",
  "system.help.legal": "Juridisk information",
  "team.create.flag.error.description": "Vi kunde inte skapa ett team åt dig. Försök snart igen.",
  "team.create.flag.error.title": "Oj då! Något gick fel.",
  "team.created.flag.description": "{membersCount, plural, one {Du har bjudit in {membersCount} person till teamet ”'{'teamName'}'”} other {Du har bjudit in {membersCount} personer till teamet ”'{'teamName'}'”}}",
  "team.created.flag.title": "Nytt team har skapats",
  "team.created.flag.view": "Visa team",
  "template.variables.fabric.section.message": "Den här mallen använder variabler. När du fyller i dem kommer den information du tillhandahåller att bli en del av innehållet på din nya sida.",
  "templates.name": "Mallar",
  "text.file": "Textfil",
  "text.selected": "Vald",
  "tinymce.advanced.block": "Format",
  "tinymce.advanced.blockquote": "Citat",
  "tinymce.advanced.blockquote_shortcut": "Ctrl+8",
  "tinymce.advanced.bold_desc": "Fetstil",
  "tinymce.advanced.bold_shortcut": "Ctrl+B",
  "tinymce.advanced.bullist_desc": "Punktlista",
  "tinymce.advanced.bullist_shortcut": "Ctrl+Skift+B",
  "tinymce.advanced.charmap_desc": "Tecken",
  "tinymce.advanced.forecolor_desc": "Välj textfärg",
  "tinymce.advanced.formatting_desc": "Formaterar",
  "tinymce.advanced.h1": "Rubrik 1",
  "tinymce.advanced.h1_shortcut": "Ctrl+1",
  "tinymce.advanced.h2": "Rubrik 2",
  "tinymce.advanced.h2_shortcut": "Ctrl+2",
  "tinymce.advanced.h3": "Rubrik 3",
  "tinymce.advanced.h3_shortcut": "Ctrl+3",
  "tinymce.advanced.h4": "Rubrik 4",
  "tinymce.advanced.h4_shortcut": "Ctrl+4",
  "tinymce.advanced.h5": "Rubrik 5",
  "tinymce.advanced.h5_shortcut": "Ctrl+5",
  "tinymce.advanced.h6": "Rubrik 6",
  "tinymce.advanced.h6_shortcut": "Ctrl+6",
  "tinymce.advanced.headings": "Rubrikerna 1 till 6",
  "tinymce.advanced.headings_shortcut": "Ctrl+1..6",
  "tinymce.advanced.hr_desc": "Horisontell linje",
  "tinymce.advanced.indent_desc": "Indrag",
  "tinymce.advanced.italic_desc": "Kursiv",
  "tinymce.advanced.italic_shortcut": "Ctrl+I",
  "tinymce.advanced.justifycenter_desc": "Centrera",
  "tinymce.advanced.justifyfull_desc": "Justera",
  "tinymce.advanced.justifyleft_desc": "Vänsterjustera",
  "tinymce.advanced.justifyright_desc": "Högerjustera",
  "tinymce.advanced.numlist_desc": "Numrerad lista",
  "tinymce.advanced.numlist_shortcut": "Ctrl+Skift+N",
  "tinymce.advanced.outdent_desc": "Minska indrag",
  "tinymce.advanced.paragraph": "Stycke",
  "tinymce.advanced.paragraph_shortcut": "Ctrl+0",
  "tinymce.advanced.pre": "Förformaterad",
  "tinymce.advanced.pre_shortcut": "Ctrl+7",
  "tinymce.advanced.redo_desc": "Gör om",
  "tinymce.advanced.redo_shortcut": "Ctrl+Y",
  "tinymce.advanced.striketrough_desc": "Överstrykning",
  "tinymce.advanced.striketrough_shortcut": "Ctrl+Skift+S",
  "tinymce.advanced.sub_desc": "Nedsänkt text",
  "tinymce.advanced.sup_desc": "Upphöjd text",
  "tinymce.advanced.tasklist_desc": "Uppgiftslista",
  "tinymce.advanced.tasklist_shortcut": "[ sedan ]",
  "tinymce.advanced.underline_desc": "Understrykning",
  "tinymce.advanced.underline_shortcut": "Ctrl+U",
  "tinymce.advanced.undo_desc": "Ångra",
  "tinymce.advanced.undo_shortcut": "Ctrl+Z",
  "tinymce.advanced.unlink_desc": "Avlänka",
  "tinymce.atlassian.help": "Hjälp",
  "tinymce.atlassian.insert_menu": "Infoga",
  "tinymce.atlassian.insert_menu.charmap_desc": "Infoga symbol",
  "tinymce.atlassian.insert_menu.content_desc": "Infoga innehåll",
  "tinymce.atlassian.insert_menu.hr_desc": "Infoga horisontell linje (----)",
  "tinymce.atlassian.insert_menu.macro_desc": "Infoga makro",
  "tinymce.atlassian.insert_menu.tooltip": "Infoga mer innehåll",
  "tinymce.atlassian.monospace": "Fast teckenbredd",
  "tinymce.atlassian.monospace_desc": "Formatera text med fast teckenbredd",
  "tinymce.atlassian.more_menu": "Mer",
  "tinymce.atlassian.remove_formatting": "Rensa formatering",
  "tinymce.atlassian.remove_formatting_desc": "Rensar formatering för den markerade texten",
  "tinymce.auiwindowmanager.cancel": "Avbryt",
  "tinymce.auiwindowmanager.ok": "Okej",
  "tinymce.autocomplete.web.resource.name": "Webbresurser för Confluence autoomplete",
  "tinymce.autocomplete.web.resource.only.name": "Webbresurser för Confluence autocomplete utan beroenden",
  "tinymce.charmap.web.resource.name": "Webbresurser för TinyMCE-teckenkarta",
  "tinymce.charmap_dlg.title": "Infoga symbol",
  "tinymce.colorpicker.color": "Färg",
  "tinymce.colorpicker.more_colors": "Fler färger",
  "tinymce.colorpicker.picker_tab": "Väljare",
  "tinymce.colorpicker.picker_title": "Färgväljare",
  "tinymce.colorpicker.title": "Välj en färg",
  "tinymce.colorpicker.web.resource.name": "Webbresurser för Confluences färgväljare",
  "tinymce.confluence.conf_emoji": "Emoji",
  "tinymce.confluence.conf_emoticon": "Emotikon",
  "tinymce.confluence.conf_emoticon_desc": "Infoga emotikon",
  "tinymce.confluence.conf_file": "Filer och bilder",
  "tinymce.confluence.conf_file_desc": "Infoga filer och bilder",
  "tinymce.confluence.conf_file_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_image": "Bild",
  "tinymce.confluence.conf_image_desc": "Infoga bild",
  "tinymce.confluence.conf_image_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_link": "Länk",
  "tinymce.confluence.conf_link_desc": "Infoga länk",
  "tinymce.confluence.conf_link_shortcut": "Ctrl+K",
  "tinymce.confluence.conf_macro_browser": "Makro",
  "tinymce.confluence.conf_macro_browser_desc": "Infoga makro",
  "tinymce.confluence.conf_macro_browser_shortcut": "Ctrl+Skift+A",
  "tinymce.confluence.conf_media": "Bild/Media",
  "tinymce.confluence.conf_other_macros_desc": "Andra makron ...",
  "tinymce.confluence.conf_shortcuts_help": "Hjälp för tangentbordsgenvägar",
  "tinymce.confluence.conf_tasklist": "Uppgiftslista",
  "tinymce.confluence.conf_tasklist_desc": "Infoga uppgiftslista",
  "tinymce.confluence.conf_tasklist_shortcut": "[ sedan ]",
  "tinymce.confluence.conf_widget_desc": "Widget",
  "tinymce.confluence.conf_wikimarkup": "Markup",
  "tinymce.confluence.conf_wikimarkup.insert.label": "Infoga",
  "tinymce.confluence.conf_wikimarkup_confluence_label": "Confluence-wiki",
  "tinymce.confluence.conf_wikimarkup_conversion_errors": "Konverteringsfel för wikimarkup",
  "tinymce.confluence.conf_wikimarkup_desc": "Infoga markup",
  "tinymce.confluence.conf_wikimarkup_hint": "Tips: du kan även ange wikimarkup direkt i editorn där det kommer att formateras medan du skriver.",
  "tinymce.confluence.conf_wikimarkup_info_title": " Ange wiki-markup eller markdown nedan. Confluence konverterar ditt innehåll till editorformat och infogar det på din sidan.",
  "tinymce.confluence.conf_wikimarkup_markdown_label": "Markdown",
  "tinymce.confluence.conf_wikimarkup_preview_label": "Förhandsgranskning",
  "tinymce.confluence.conf_wikimarkup_shortcut": "Ctrl+Skift+D",
  "tinymce.confluence.conf_wikimarkup_timeout": "Servern tog för lång tid på sig att konvertera wikimarkupen. Detta kan vara ett tillfälligt problem så du kan försöka igen.",
  "tinymce.confluence.files": "Filer",
  "tinymce.confluence.help_desc": "Hjälp",
  "tinymce.confluence.htmlsource": "Källa",
  "tinymce.confluence.htmlsource_desc": "Visa HTML-källa",
  "tinymce.confluence.layout.menu": "Sidlayout",
  "tinymce.confluence.layout.none": "Ingen layout",
  "tinymce.confluence.layout.three_col": "Tre kolumner",
  "tinymce.confluence.layout.three_col_sidebars": "Tre kolumner (vänster och höger sidofält)",
  "tinymce.confluence.layout.three_col_simple": "Tre kolumner (enkel)",
  "tinymce.confluence.layout.two_col": "Två kolumner",
  "tinymce.confluence.layout.two_col_left": "Två kolumner (vänster sidofält)",
  "tinymce.confluence.layout.two_col_right": "Två kolumner (höger sidofält)",
  "tinymce.confluence.layout.two_col_simple": "Två kolumner (enkel)",
  "tinymce.confluence.layout.two_col_simple_left": "Två kolumner (enkel, vänster sidofält)",
  "tinymce.confluence.layout.two_col_simple_right": "Två kolumner (enkel, höger sidofält)",
  "tinymce.confluence.macro_insert": "Infoga makrot '{'0'}'",
  "tinymce.confluence.macro_other": "Andra makron",
  "tinymce.confluence.macro_other_desc": "Öppna makrobläddraren",
  "tinymce.confluence.placeholder.inline.tasks": "Skriv in din uppgift här och använd ”@” för att tilldela till en användare och ”//” för att välja ett färdigdatum",
  "tinymce.confluence.preview": "Förhandsgranskning",
  "tinymce.confluence.preview_shortcut": "Ctrl+Skift+E",
  "tinymce.confluence.save_shortcut": "Ctrl+S",
  "tinymce.confluence.settings_desc": "Inställningar för editor",
  "tinymce.confluence_dlg.insertbutton.title": "Infoga",
  "tinymce.confluence_dlg.insertimage.title": "Infoga bild",
  "tinymce.confluence_dlg.insertlink.title": "Infoga länk",
  "tinymce.emotions.emotions_desc": "Emotikoner",
  "tinymce.emotions.web.resource.name": "Webbresurser för TinyMCE-emotikoner",
  "tinymce.emotions_dlg.add": "Plus (+)",
  "tinymce.emotions_dlg.biggrin": "Stor leende :)",
  "tinymce.emotions_dlg.broken_heart": "Brustet hjärta </3",
  "tinymce.emotions_dlg.check": "Bock (/)",
  "tinymce.emotions_dlg.desc": "Emotikoner",
  "tinymce.emotions_dlg.error": "Fel (x)",
  "tinymce.emotions_dlg.forbidden": "Minus (-)",
  "tinymce.emotions_dlg.heart": "Hjärta <3",
  "tinymce.emotions_dlg.help_16": "Frågetecken (?)",
  "tinymce.emotions_dlg.information": "Info (i)",
  "tinymce.emotions_dlg.lightbulb": "Glödlampa av (off)",
  "tinymce.emotions_dlg.lightbulb_on": "Glödlampa på (on)",
  "tinymce.emotions_dlg.sad": "Ledsen :(",
  "tinymce.emotions_dlg.smile": "Leende :)",
  "tinymce.emotions_dlg.star_blue": "Blå stjärna (*b)",
  "tinymce.emotions_dlg.star_green": "Grön stjärna (*g)",
  "tinymce.emotions_dlg.star_red": "Röd stjärna (*r)",
  "tinymce.emotions_dlg.star_yellow": "Gul stjärna (*y)",
  "tinymce.emotions_dlg.thumbs_down": "Tummen ner (n)",
  "tinymce.emotions_dlg.thumbs_up": "Tummen up (y)",
  "tinymce.emotions_dlg.title": "Infoga emotikon",
  "tinymce.emotions_dlg.tongue": "Tunga :p",
  "tinymce.emotions_dlg.warning": "Varning (!)",
  "tinymce.emotions_dlg.wink": "Blinkning ;)",
  "tinymce.fabric.migration.dialog.action": "Fortsätt redigera",
  "tinymce.fabric.migration.dialog.content": "Bara lugn, du har inte förlorat dina ändringar. Vi behövde bara uppdatera din sida.",
  "tinymce.fabric.migration.dialog.title": "Vi har just uppdaterat din redigeringsupplevelse",
  "tinymce.formatting.paragraph": "Normal text",
  "tinymce.full_screen.toolbar_item": "Helskärm",
  "tinymce.full_screen.toolbar_item_title": "Starta editorn i helskärm.",
  "tinymce.hints.autoformat.code": "Tips: Skriv ”<strong>'{{'code'}}'</strong>” för att snabbt infoga text med fast teckenbredd.",
  "tinymce.hints.autoformat.heading1": "Tips: Skriv \"<strong>h1. Titel</strong>\" för att snabbt infoga en Rubrik 1.",
  "tinymce.hints.autoformat.heading3": "Tips: Skriv \"<strong>h3. Titel</strong>\" för att snabbt infoga en Rubrik 3.",
  "tinymce.hints.dnd": "Tips: du kan dra och släppa bilder och Office-filer från din dator rakt in i denna editor",
  "tinymce.hints.drafts": "Tips: Confluence sparar utkast automatiskt. Om du någonsin förlorar ett fönster kan du återställa ditt arbete från menyn ”Användarnamn -> Utkast”.",
  "tinymce.hints.insert.bullet.list": "Tips: tryck på <strong>Ctrl+Skift+B</strong> för att starta en punktlista.",
  "tinymce.hints.insert.heading": "Tips: tryck på <strong>Ctrl+1</strong> för att skapa en rubrik av nivå 1, <strong>Ctrl+2</strong> för nivå 2 och så vidare.",
  "tinymce.hints.insert.image": "Tips: tryck på <strong>Ctrl+M</strong> för att öppna bildbläddraren.",
  "tinymce.hints.insert.image.end": "Tips: tryck på <strong>Ctrl+Skift+M</strong> efter ett ord för att hitta och infoga relevanta bilder.",
  "tinymce.hints.insert.image.on.page": "Tips: skriv \"<strong>!</strong>\" för att se bilderna som är bifogade till sidan och infoga en av dem.",
  "tinymce.hints.insert.image.search": "Tips: skriv \"<strong>!</strong>\" och delar av ett bildnamn för att hitta och infoga bilden.",
  "tinymce.hints.insert.link": "Tips: tryck på <strong>Ctrl+K</strong> för att öppna länkbläddraren.",
  "tinymce.hints.insert.link.end": "Tips: tryck <strong>Ctrl+Skift+K</strong> efter ett ord för att hitta och länka till relevanta sidor. Tryck igen för fler förslag.",
  "tinymce.hints.insert.link.newpage": "Tips: skriv \"<strong>[</strong>\" och titeln på en ny sida som du vill skapa för att se förslag på länk att infoga.",
  "tinymce.hints.insert.link.recently.viewed": "Tips: skriv \"<strong>[</strong>\" för att se en lista över föreslagna sidor och infoga en länk.",
  "tinymce.hints.insert.link.search": "Tips: skriv \"<strong>[</strong>\" och delar av en sidtitel för att hitta och länka till den sidan.",
  "tinymce.hints.insert.link.user.mention": "Tips: du kan nämna någon i Confluence genom att skriva \"<strong>@</strong>\" och sedan deras namn.",
  "tinymce.hints.insert.macro": "Tips: tryck på <strong>Ctrl+Skift+A</strong> för att öppna makrobläddraren.",
  "tinymce.hints.insert.macro.toc": "Tips: Låt Confluence generera en innehållsförteckning för denna sida. Använd \"Infoga -> Innehållsförteckning\"",
  "tinymce.hints.insert.newline": "Tips: Tryck på <strong>Skift+Enter</strong> för att infoga ett nytt stycke utan mellanrum",
  "tinymce.hints.insert.numbered.list": "Tips: tryck på <strong>Ctrl+Skift+N</strong> för att påbörja en numrerad lista.",
  "tinymce.hints.insert.table": "Tips: tryck på <strong>Ctrl+Skift+I</strong> för att infoga en tabell.",
  "tinymce.hints.insert.wikimarkup": "Tips: editorn kommer att konvertera wikimarkup automatiskt medan du skriver.",
  "tinymce.hints.insert.wikimarkup.dialog": "Tips: tryck <strong>Ctrl+Skift+D</strong> för att öppna dialogrutan för Wiki Markup.",
  "tinymce.hints.table.rows.copy": "Tips: tryck på <strong>Ctrl+Skift+C</strong> för att kopiera en rad och <strong>Ctrl+Skift+V</strong> för att klistra in en rad i en tabell.",
  "tinymce.hints.table.rows.cut": "Tips: Tryck på <strong>Ctrl+Skift+X</strong> för att klippa ut en rad och <strong>Ctrl+Skift+V</strong> för att klistra in en rad i en tabell.",
  "tinymce.macro.preview.exception": "Ett undantag inträffade när makrot förhandsgranskades. Undantag: {0}",
  "tinymce.macro.unknownMacro": "Makrot '{'0'}' är okänt. Det kan ha tagits bort från systemet.",
  "tinymce.popup_blocked": "Webbläsaren har blockerat ett poppupfönster som öppnades av editorn.",
  "tinymce.propertypanel.images.border": "Kantlinje",
  "tinymce.propertypanel.images.border.tooltip": "Visa en kantlinje runt bilden",
  "tinymce.propertypanel.images.large": "Stor",
  "tinymce.propertypanel.images.large.tooltip": "Ändra bildstorlek till stor och länka till originalet",
  "tinymce.propertypanel.images.link.create": "Länk",
  "tinymce.propertypanel.images.link.create.tooltip": "Länka denna bild till annat innehåll",
  "tinymce.propertypanel.images.link.edit": "Redigera länk",
  "tinymce.propertypanel.images.link.edit.tooltip": "Redigera länken för denna bild",
  "tinymce.propertypanel.images.link.remove": "Avlänka",
  "tinymce.propertypanel.images.link.remove.tooltip": "Ta bort länken för denna bild",
  "tinymce.propertypanel.images.medium": "Medium",
  "tinymce.propertypanel.images.medium.tooltip": "Ändra bildstorleken till medium och länka till originalet",
  "tinymce.propertypanel.images.original": "Original",
  "tinymce.propertypanel.images.original.tooltip": "Återställ bildstorlek till original",
  "tinymce.propertypanel.images.sizing.tooltip": "Ändra bildstorlek till en specifik bredd",
  "tinymce.propertypanel.images.small": "Liten",
  "tinymce.propertypanel.images.small.tooltip": "Ändra bildstorleken till liten och länka tillbaka till originalet",
  "tinymce.propertypanel.links.edit": "Redigera",
  "tinymce.propertypanel.links.edit.tooltip": "Redigera länken i en dialogruta",
  "tinymce.propertypanel.links.goto": "Gå till länk",
  "tinymce.propertypanel.links.goto.disabled.tooltip": "Denna länk går till innehåll på sidan du redigerar",
  "tinymce.propertypanel.links.unlink": "Avlänka",
  "tinymce.propertypanel.links.unlink.tooltip": "Ersätt länken med texten den innehåller",
  "tinymce.searchreplace.replace_desc": "Hitta/ersätt",
  "tinymce.searchreplace.search_desc": "Hitta",
  "tinymce.searchreplace_dlg.allreplaced.plural": "{0} ersättningar gjordes",
  "tinymce.searchreplace_dlg.allreplaced.singular": "1 ersättning gjordes",
  "tinymce.searchreplace_dlg.close": "Stäng",
  "tinymce.searchreplace_dlg.direction": "Riktning",
  "tinymce.searchreplace_dlg.down": "Ner",
  "tinymce.searchreplace_dlg.findlabel": "Hitta",
  "tinymce.searchreplace_dlg.findnext": "Nästa",
  "tinymce.searchreplace_dlg.findprevious": "Föregående",
  "tinymce.searchreplace_dlg.findwhat": "Hitta vad",
  "tinymce.searchreplace_dlg.mcase": "Matcha skiftläge",
  "tinymce.searchreplace_dlg.notfound": "Inga ersättningar gjordes",
  "tinymce.searchreplace_dlg.replace": "Ersätt",
  "tinymce.searchreplace_dlg.replace_title": "Hitta/ersätt",
  "tinymce.searchreplace_dlg.replaceall": "Ersätt alla",
  "tinymce.searchreplace_dlg.replacelabel": "Ersätt",
  "tinymce.searchreplace_dlg.search_title": "Hitta",
  "tinymce.searchreplace_dlg.searchnext_desc": "Hitta igen",
  "tinymce.searchreplace_dlg.up": "Upp",
  "tinymce.style.show-eol-markers": "Â¶",
  "tinymce.style.show-eol-markers.title": "Visa/dölj radslutsmarkörer",
  "tinymce.table": "Tabell",
  "tinymce.table.cell": "Cell",
  "tinymce.table.col": "Kolumn",
  "tinymce.table.col_after_desc": "Infoga kolumn efter",
  "tinymce.table.col_after_desc_shortcut_mac": "Control+Option+→",
  "tinymce.table.col_after_desc_shortcut_win": "Alt+Shift+→",
  "tinymce.table.col_before_desc": "Infoga kolumn här",
  "tinymce.table.col_before_desc_shortcut_mac": "Control+Option+←",
  "tinymce.table.col_before_desc_shortcut_win": "Alt+Shift+←",
  "tinymce.table.col_copy_desc": "Kopiera tabellkolumn",
  "tinymce.table.col_cut_desc": "Klipp ut tabellkolumn",
  "tinymce.table.col_highlight": "Rubrikkolumn",
  "tinymce.table.col_paste_desc": "Klistra in tabellkolumn",
  "tinymce.table.copy_row_desc": "Kopiera tabellrad",
  "tinymce.table.copy_row_shortcut": "Ctrl+Skift+C",
  "tinymce.table.cut_row_desc": "Klipp ut tabellrad",
  "tinymce.table.cut_row_shortcut": "Ctrl+Skift+X",
  "tinymce.table.del": "Ta bort tabell",
  "tinymce.table.delete_col_desc": "Ta bort kolumn",
  "tinymce.table.delete_row_desc": "Radera rad",
  "tinymce.table.desc": "Infoga tabell",
  "tinymce.table.fixed_width": "Fast bredd",
  "tinymce.table.fixed_width_tooltip": "Dra i kolumnkanterna för att ange bredden. Tabellen visas alltid med bredden du har angett.",
  "tinymce.table.highlight_colour": "Markeringsfärg",
  "tinymce.table.merge_cells_desc": "Sammanfoga tabellceller",
  "tinymce.table.more.heading": "Tabellinställningar",
  "tinymce.table.numbering_column_desc": "Infoga numreringskolumn",
  "tinymce.table.paste_row_after_desc": "Klistra in rad efter",
  "tinymce.table.paste_row_before_desc": "Klistra in tabellrad",
  "tinymce.table.paste_row_before_shortcut": "Ctrl+Skift+V",
  "tinymce.table.responsive": "Följsam",
  "tinymce.table.responsive_tooltip": "Tabellkolumner blir bredare när du lägger till innehåll. Dra i kolumnkanterna för att ställa in deras bredd relativt varandra och sidan.",
  "tinymce.table.row": "Rad",
  "tinymce.table.row_after_desc": "Infoga rad efter",
  "tinymce.table.row_after_desc_shortcut_mac": "Control+Option+↓",
  "tinymce.table.row_after_desc_shortcut_win": "Alt+Shift+↓",
  "tinymce.table.row_after_shortcut": "Alt+↓",
  "tinymce.table.row_before_desc": "Infoga rad före",
  "tinymce.table.row_before_desc_shortcut_mac": "Control+Option+↑",
  "tinymce.table.row_before_desc_shortcut_win": "Alt+Shift+↑",
  "tinymce.table.row_before_shortcut": "Alt+↑",
  "tinymce.table.row_highlight": "Rubrikrad",
  "tinymce.table.selection_highlight": "Ändra cellfärg",
  "tinymce.table.split_cells_desc": "Dela upp sammanfogade tabellceller",
  "tinymce.table_dlg.cols": "Kolumner",
  "tinymce.table_dlg.equal.width.columns": "Kolumner med samma bredd",
  "tinymce.table_dlg.fullwidth": "Full bredd",
  "tinymce.table_dlg.heading": "Första raden är en rubrik",
  "tinymce.table_dlg.invalid_table_field": "Rader och kolumner måste båda vara tal större än 0.",
  "tinymce.table_dlg.rows": "Rader",
  "tinymce.table_dlg.sizetofit": "Storlek till innehåll",
  "tinymce.table_dlg.title": "Infoga tabell",
  "tinymce.table_dlg.width": "Bredd",
  "tinymce.table_shortcut": "Ctrl+Skift+I",
  "tinymce.tablepicker.insert_table": "Tabell",
  "tinymce.tablepicker.insert_table_title": "Infoga tabell",
  "tinymce.tablepicker.nested_table_unsupported": "Stöd saknas för tabeller inuti annat innehåll",
  "tinymce.tablepicker.pickerbox.tooltip": "Håll inne SKIFT för en tabell utan rubrik.",
  "tinymce.templates.actions.defined": "Objekt att infoga på denna sida.",
  "tinymce.templates.insert-template": "Mall",
  "tinymce.templates.insert-template.tooltip": "Infoga mallobjekt på denna sida.",
  "tinymce.templates.placeholder": "Instruktionstext",
  "tinymce.templates.placeholder.add": "Platshållare",
  "tinymce.templates.placeholder.add.tooltip": "Infoga en platshållare för text på sidan.",
  "tinymce.templates.placeholder.tooltip": "Försvinner när en användare skriver och syns inte när en sida visas.",
  "tinymce.templates.variables.add": "Ny variabel",
  "tinymce.templates.variables.add.tooltip": "Lägg till ett nytt fält på sidan som användaren av mallen kan fylla i.",
  "tinymce.templates.variables.defined": "Variabler att infoga på denna sida.",
  "tinymce.templates.variables.insert.tooltip": "Infoga fältet '{'0'}' på sidan så att mallanvändaren kan fylla i det.",
  "tinymce.templates.variables.manage": "Hantera variabler",
  "tinymce.templates.variables.none": "Inga variabler har definierats",
  "tinymce.templates.variables.none.tooltip": "Inga variabler har skapats.",
  "tinymce.tools.toolbar_item_hide": "Dölj verktyg",
  "tinymce.tools.toolbar_item_hide_title": "Dölj verktygsfälten",
  "tinymce.tools.toolbar_item_show": "Visa verktyg",
  "tinymce.tools.toolbar_item_show_title": "Visa verktygsfälten",
  "tinymce.web.css.resource.name": "Webbresurser för Confluences CSS-editor",
  "tinymce.web.js.resource.name": "Javascript-webbresurser för Confluence editor",
  "tinymce.web.resource.name": "Webbresurser för Confluence-editor",
  "title.add.blogpost": "Lägg till blogginlägg.",
  "title.add.page": "Lägg till sida",
  "title.add.page.template": "Skapa mall",
  "title.comment": "Kommentar",
  "title.dashboard": "Dashboard",
  "title.edit.page.template": "Redigera mall",
  "title.manage.groups": "Grupper",
  "title.name": "Titel",
  "type.allcontent": "Allt innehåll",
  "unknown.file": "Fil",
  "unsaved.comment.lost": "Din kommentar kommer att försvinna.",
  "unsaved.content.lost": "Ändringar som du gör kanske inte sparas.",
  "unsaved.template.lost": "Dina osparade ändringar till mallen kommer att gå förlorade.",
  "untitled.draft.title": "Obetitlad",
  "upm.marketplace.section": "Atlassian Marketplace",
  "usermanagement.label": "Användarhantering",
  "usermanagement.parent.label": "Webbplatsadministration",
  "users.name": "Användare",
  "view-changes-dialog.close.dialog": "Stäng",
  "view-changes-dialog.editor.quit-dialog.title.diff": "Opublicerade ändringar",
  "view.change": "visa ändring",
  "view.profile": "Visa profil",
  "viewdrafts.page.desc": "När du redigerar en sida utan att publicera ändringarna skapas ett utkast. Tryck på <b>Fortsätt</b> för att fortsätta redigera eller publicera ändringarna.",
  "welcome.message.edit": "Dela användbara länkar, meddelanden och information här",
  "welcome.message.edit.link": "Anpassa",
  "word.file": "Microsoft Word-dokument",
  "word.template.file": "Microsoft Word-mall",
  "word97.file": "Microsoft Word 97-dokument",
  "word97.template.file": "Microsoft Word 97-mall",
  "xml.file": "XML-fil",
  "yes.name": "Ja",
  "your.profile.and.settings": "Din profil och dina inställningar",
  "zip.file": "ZIP-arkiv"
}